/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
/* eslint-disable react/button-has-type */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import React, { useState, useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import { protectedResources, siteData } from "authConfig";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import S3FileUpload from "react-s3";
import { PolarArea, Radar } from "react-chartjs-2";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Slider,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Switch,
  TextField,
  Tooltip as MuiTooltip,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";
import MDAlert from "components/MDAlert";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import { Link } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Autocomplete from "@mui/material/Autocomplete";
import dayjs from "dayjs";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import UndoIcon from "@mui/icons-material/Undo";
import ArticleIcon from "@mui/icons-material/Article";
import ArchiveIcon from "@mui/icons-material/ArchiveOutlined";
import RestoreIcon from "@mui/icons-material/Restore";
import Icon from "@mui/material/Icon";
import AWS from "aws-sdk";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { lab } from "chroma-js";
import Plot from "react-plotly.js";
import EmergingRiskRadar from "./EmergingRiskRadar";
import RiskSummaryPanel from "./RiskSummaryPanel";
import MiniRiskGauge from "./MiniRiskGauge";
import WatchlistSummary from "./WatchlistSummary";
import SignpostFinderDialog from "./SignpostFinderDialog";
import AddSignpostForm from "./AddSignpostForm";
import { PlausibilityPickerDialog, ConsequencePickerDialog } from "./RiskMatrixPickers";
import CombinedSignpostChart from "./CombinedSignpostChart";
import Scenario from "./scenario.component";
import DynamicTextBoxes from "./DynamicTextBoxes";
import SignpostChart from "./SignpostChart";
import QualitativeSignpostCard from "./QualitativeSignpostCard";

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend, ArcElement);
// ID89 — the signpost form now lives in <AddSignpostForm/>; the old inline copy is kept
// behind this flag (dead) until fully retired.
const SHOW_LEGACY_SIGNPOST_FORM = false;
const S3_BUCKET = "6thsenseriskinsights";
const REGION = "ap-southeast-2";
const ACCESS_KEY = "AKIAUUNF7R2PQMUPDVJB";
const SECRET_ACCESS_KEY = "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";

const config = {
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
};
function PolarScatterChart() {
  const data = [
    {
      type: "scatterpolar",
      mode: "markers", // Use 'markers' to create a scatter plot without connecting the points
      r: [1, 2, 3, 4, 5],
      theta: ["A", "B", "C", "D", "A"],
      name: "Category 1",
      marker: {
        symbol: "circle", // Set the marker symbol (optional)
        size: 12, // Set the marker size (optional)
      },
    },
  ];

  const layout = {
    polar: {
      radialaxis: {
        visible: true,
        range: [0, 5],
      },
    },
    showlegend: true,
  };

  return <Plot data={data} layout={layout} />;
}
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Parse money strings honouring magnitude suffixes: "$20M" → 20,000,000.
function parseMoney(v) {
  const s = String(v || "")
    .trim()
    .toLowerCase();
  const n = parseFloat(s.replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(n)) return 0;
  const suffix = s.replace(/[0-9.,$\s-]/g, ""); // letters only
  if (suffix.startsWith("k") || suffix.startsWith("thou")) return n * 1e3;
  if (suffix.startsWith("t")) return n * 1e12; // trillion
  if (suffix.startsWith("b")) return n * 1e9; // billion / bn
  if (suffix.startsWith("m")) return n * 1e6; // million / mn / mm
  return n;
}

function AnticipateEmergingRisk() {
  const location = useLocation();
  const navigate = useNavigate();
  const { execute } = useFetchWithMsal({
    scopes: [siteData?.apiScopes],
  });
  const executeRef = useRef(execute);
  executeRef.current = execute;

  const [TableData, setTableData] = useState(null);
  // get appetite type for column heading

  //  get data from api

  // for save button rendering. Step 2 is optional — a Horizon Scan is auto-set-up on save, so manual
  // signposts are an extra, not a requirement (labelled so the user doesn't think it's mandatory).
  const steps = ["Risk Details", "Signposts (optional)"];

  // Update the edited data for each row using the index as the key
  const [updatedData, setUpdatedData] = useState([]);
  const [activeStep, setActiveStep] = React.useState(0);

  // Pre-fill from horizon scan navigation state (if arriving via "Save & Monitor as Emerging Risk")
  const horizonPrefill = location.state?.prefill || null;

  const [RiskDetails, setRiskDetails] = useState(
    horizonPrefill
      ? { Title: horizonPrefill.title || "", Description: horizonPrefill.description || "" }
      : {}
  );
  const [SignPost, setSignPost] = useState({});
  const [allSubCats, setAllSubCats] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(horizonPrefill?.category || "");
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(horizonPrefill?.subCategory || "");
  // ID78 — taxonomy category is chosen via a full-taxonomy pop-up rather than two dropdowns.
  const [taxPickerOpen, setTaxPickerOpen] = useState(false);
  const [taxSearch, setTaxSearch] = useState("");
  const [taxExpanded, setTaxExpanded] = useState(null);
  const [selectedSignPost, setSelectedSignPost] = useState("");
  const [baseVelocity, setBaseVelocity] = useState("");
  // ID98 — single Time Horizon & Velocity value for the overall risk (no longer per-scenario).
  // Seeded from an advanced theme's plausibility so the selector pre-selects in timeframe_velocity mode.
  const [overallVelocity, setOverallVelocity] = useState(horizonPrefill?.velocity || "");
  // ID171 — optional free-text description for the (overall) Plausibility value.
  const [plausibilityDescription, setPlausibilityDescription] = useState("");
  // ID170 — Response Status options come from the Appetite Settings config (admin-editable).
  const [responseStatusOptions, setResponseStatusOptions] = useState([
    { label: "Prepared and Tested" },
    { label: "Partially Prepared" },
    { label: "Unprepared" },
  ]);
  // ID79/ID80 — table-pop-up pickers
  const [plausPickerOpen, setPlausPickerOpen] = useState(false);
  const [consPicker, setConsPicker] = useState({ open: false, scIdx: null });
  const [timeFrame, setTimeFrame] = useState(horizonPrefill?.timeFrame || "medium-term");
  const [linkedHorizonTheme, setLinkedHorizonTheme] = useState(
    horizonPrefill?.linkedHorizonTheme || ""
  );
  // Server-shaped view of THIS risk (scenarioRows + signpost proximity/alert) from the radar-data
  // endpoint — drives the board-ready summary panel + the mini gauge, so they match the radar exactly.
  const [radarRisk, setRadarRisk] = useState(null);
  const [horizonThemes, setHorizonThemes] = useState([]);
  // ID75 — searchable modal picker for linking a Horizon Scan theme.
  const [themePickerOpen, setThemePickerOpen] = useState(false);
  const [themeSearch, setThemeSearch] = useState("");
  const [evalCriteria, setEvalCriteria] = useState({
    plausibilityRows: [],
    likelihoodRows: [], // ID172 — separate per-mode data
    consequenceLevels: [],
    consequenceRows: [],
    prioritisationMatrix: null, // ID54 — residual-threshold picker
    plausibilityMode: "timeframe_velocity", // ID172
  });
  // ID172 — chosen likelihood band (used when plausibilityMode === 'likelihood').
  const [likelihood, setLikelihood] = useState(horizonPrefill?.likelihood || "");
  const isLikelihoodMode = evalCriteria.plausibilityMode === "likelihood";
  const [fromDt, setFromDt] = React.useState(dayjs("2022-04-17"));
  const [selectedFile, setSelectedFile] = useState(null);
  // If arriving from horizon scan prefill, open create form immediately
  const [createRisk, setCreateRisk] = useState(!!horizonPrefill);
  const [reload, setReload] = useState(false);
  const [riskDetailsData, setRiskDetailsData] = useState([]);
  const [showSignPost, setShowSignPost] = useState(false);
  const [value, setValue] = React.useState(0);
  const [radarData, setRadardata] = useState({});
  const [radarOptions, setRadarOptions] = useState({});
  const [scenario, setScenario] = useState("Base");
  const [watchlistTab, setWatchlistTab] = useState(0); // 0 = Radar, 1 = Summary
  const [showDrafts, setShowDrafts] = useState(true); // dashboard list: show drafts so new/saved risks are visible
  const [showArchived, setShowArchived] = useState(false); // reveal the archived (closed) risks panel
  const [archivedRisks, setArchivedRisks] = useState([]);
  const [archiveDialogOpen, setArchiveDialogOpen] = useState(false); // archive warning + reason dialog
  const [archiveReasonText, setArchiveReasonText] = useState(""); // mandatory free-text archive reason
  // ID195 — restore confirmation: warn that the risk comes back in Draft (needs verify + publish),
  // then open it on OK. restoreTarget holds the risk being restored (from panel or detail view).
  const [restoreDialogOpen, setRestoreDialogOpen] = useState(false);
  const [restoreTarget, setRestoreTarget] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // styled delete warning confirmation
  const [themeDetailOpen, setThemeDetailOpen] = useState(false); // ID199 — qual theme detail pop-up
  const [themeDetail, setThemeDetail] = useState(null); // the theme shown in the pop-up
  const [confirmSpOpen, setConfirmSpOpen] = useState(false); // post-create signpost confirmation
  const [confirmSpList, setConfirmSpList] = useState([]); // created signposts + their thresholds
  const [commentInput, setCommentInput] = useState(""); // new commentary note
  const [commentaryTab, setCommentaryTab] = useState("latest"); // "latest" | "history"
  const [finderOpen, setFinderOpen] = useState(false); // ID96 "Find best signposts" dialog
  const [signpostDialogOpen, setSignpostDialogOpen] = useState(false); // ID89 "+ Add Signpost" pop-up
  // Phase 3 — AI "Suggest signposts" (design agent) proposal review
  const [suggestOpen, setSuggestOpen] = useState(false);
  const [suggestLoading, setSuggestLoading] = useState(false);
  const [suggestions, setSuggestions] = useState(null);
  const [pickQuant, setPickQuant] = useState({});
  // Qualitative trigger suggestions are no longer offered (Suggest signposts = quantitative only;
  // qualitative is covered by the linked Horizon Scan theme), so the pickTrig state was removed.
  const [creatingSp, setCreatingSp] = useState(false);
  const [justCreated, setJustCreated] = useState(false); // ID89 nudge: prompt to add a signpost after create
  const [attachments, setAttachments] = useState([]); // ID88 risk attachments (Azure Blob)
  const [attachUploading, setAttachUploading] = useState(false);
  // false = read-only view mode; true = editing/creating
  const [editMode, setEditMode] = useState(false);
  const originalSnapshot = useRef(null); // stores {RiskDetails, scenarios} snapshot for discard
  const [saveSuccess, setSaveSuccess] = useState(false);

  // Fetch the server-shaped risk (scenarioRows + signpost proximity/alert) for the summary panel +
  // mini gauge. radar-data returns the whole portfolio; we pick THIS risk by id. Re-fetches when the
  // record changes (id or a save via `reload`).
  const riskIdForRadar = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id)) || "";
  useEffect(() => {
    if (!riskIdForRadar || createRisk) {
      setRadarRisk(null);
      return undefined;
    }
    let cancelled = false;
    executeRef
      .current(
        "GET",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/radar-data?includeDrafts=1`
      )
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res?.data) ? res.data : res?.data?.risks || [];
        setRadarRisk(list.find((r) => String(r.id || r._id) === String(riskIdForRadar)) || null);
      })
      .catch(() => {
        if (!cancelled) setRadarRisk(null);
      });
    return () => {
      cancelled = true;
    };
  }, [riskIdForRadar, createRisk, reload]);

  // Sprint 3: signpost creation form state
  const [signpostSubType, setSignpostSubType] = useState("quantitative");
  const [signpostLibraryList, setSignpostLibraryList] = useState([]);
  const [selectedLibraryEntry, setSelectedLibraryEntry] = useState(null);
  const [spThresholds, setSpThresholds] = useState([]); // [{ value, direction, scenario, scenarioLabel }]
  const [spTriggers, setSpTriggers] = useState([]); // [{ description, scenario, contextNotes }]

  // Gate 0 — generate the strict detection spec for a trigger-event row from its free text.
  const [spName, setSpName] = useState("");
  const [spDesc, setSpDesc] = useState("");
  // Sprint 3: loaded signposts for the active risk detail view
  const [activeSignposts, setActiveSignposts] = useState([]);
  const [signpostsLoading, setSignpostsLoading] = useState(false);
  // ID — in edit mode every signpost is editable at once; drafts are keyed by signpost id.
  const [editingSpDrafts, setEditingSpDrafts] = useState({});

  // Dynamic scenarios (start with 2: Best Case + Worst Case).
  // ID196 — both scenarios default to Threat/Loss (−ve), so a threat isn't mis-seeded as an upside
  // (e.g. a cyber attack's best case is a smaller loss, not a gain). The user flips Best to
  // Opportunity/Gain only for genuine upside risks. Qualitative is the default mode (quantitative kept).
  const defaultScenarios = [
    {
      id: "sc_best",
      label: "Best Case",
      velocity: "",
      threatOpp: "loss",
      consequenceMode: "qualitative",
      consequenceAmt: "",
      consequenceType: "",
      qualitative: "",
      responseStatus: "",
    },
    {
      id: "sc_worst",
      label: "Worst Case",
      velocity: "",
      threatOpp: "loss",
      consequenceMode: "qualitative",
      consequenceAmt: "",
      consequenceType: "",
      qualitative: "",
      responseStatus: "",
    },
  ];
  const [scenarios, setScenarios] = useState(() => {
    const base = defaultScenarios.map((s) => ({ ...s }));
    // Pre-populate when advancing a horizon theme. ID196 — both scenarios keep the template's
    // Threat/Loss default (the user flips Best to Opportunity/Gain only for a genuine upside); we
    // only seed the two descriptions here. Seed each side's description from the theme's gain/loss
    // mix breakdown when present, else route "why it matters" to the theme's dominant side, and
    // finally fall back to the theme summary so neither side is ever left blank on advance.
    if (horizonPrefill) {
      const isGain = horizonPrefill.threatOpp === "gain";
      const summary = horizonPrefill.description || "";
      const bestDesc =
        horizonPrefill.gainNote || (isGain ? horizonPrefill.whyItMatters : "") || summary;
      const worstDesc =
        horizonPrefill.lossNote || (isGain ? "" : horizonPrefill.whyItMatters) || summary;
      if (base[0] && bestDesc) base[0].qualitativeDescription = bestDesc;
      if (base[1] && worstDesc) base[1].qualitativeDescription = worstDesc;
      // Default Response Status on advance (was blank) — user can change it.
      base[0].responseStatus = "Partially Prepared";
      base[1].responseStatus = "Partially Prepared";
    }
    return base;
  });
  const [fromAddSignpost, setFromAddSignpost] = useState(false);
  // Publish disclaimer (tick-to-confirm) gate.
  const [publishConfirmOpen, setPublishConfirmOpen] = useState(false);
  const [publishAck, setPublishAck] = useState(false);
  const [pendingActivateId, setPendingActivateId] = useState(null);
  // Risk Horizon Scan (default per-risk scan) — scanning state + one-shot auto-run on first view.
  const [horizonScanning, setHorizonScanning] = useState(false);
  const horizonAutoRef = useRef(false);
  // Dismiss flag for the full-screen overlay (so it can be hidden while the advance sequence runs).
  const [genDismissed, setGenDismissed] = useState(false);
  // Advance sequence: one continuous overlay across AI-populate → save → horizon scan, so the user
  // just watches "assessing → saving → scanning" then reviews & publishes.
  const [advancing, setAdvancing] = useState(false);
  const [advanceSaving, setAdvanceSaving] = useState(false);
  const phase3RanRef = useRef(false); // the horizon scan (phase 3) has started at least once
  const [horizonQuery, setHorizonQuery] = useState(""); // optional user-defined scan focus
  const horizonQuerySeeded = useRef(false);
  const [showAllThemes, setShowAllThemes] = useState(true); // show ALL risk horizon themes by default (collapsible to top-6)
  // AI-populate the scenarios + likelihood from the company context.
  const [aiPopulating, setAiPopulating] = useState(false);
  const aiAutoRef = useRef(false); // one-shot auto-populate when advancing a theme to the watchlist
  // Auto-save on advance: create the draft automatically once the AI assessment has settled, so
  // advancing a theme "just adds it" (instant save) instead of leaving an unsaved form.
  const [autoSavePending, setAutoSavePending] = useState(false);
  const autoSavedRef = useRef(false); // one-shot guard so we never auto-create twice
  const postRiskDataRef = useRef(null); // always points at the latest postRiskData (avoids stale state)

  // ── Threshold/trigger ↔ Risk Details scenario linkage (items 67) ──
  // Map a Risk Details scenario to the alert key the poller understands. A signpost threshold's pole
  // is about better-vs-worse VALUE, so the Best/Worst label wins: "Best Case" is always the optimistic
  // pole and "Worst Case" the pessimistic pole — true for both threat and opportunity risks. (A threat
  // risk legitimately marks BOTH scenarios threatOpp="loss", so threatOpp alone would paint the Best
  // Case red.) Fall back to threatOpp only when the label isn't a recognisable best/worst.
  const scenarioToKey = (s) => {
    const label = (s?.label || "").toLowerCase();
    if (label.includes("best")) return "optimistic";
    if (label.includes("worst")) return "pessimistic";
    const to = (s?.threatOpp || "").toLowerCase();
    if (to.includes("gain") || to.includes("opp")) return "optimistic";
    if (to.includes("loss") || to.includes("threat")) return "pessimistic";
    return "base";
  };
  const scenarioOptionLabels = scenarios.map((s) => s.label).filter(Boolean);
  const findScenarioByLabel = (label) => scenarios.find((s) => s.label === label);
  const scenarioAmount = (s) => {
    if (!s || !String(s.consequenceAmt || "").trim()) return null;
    return parseMoney(s.consequenceAmt);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleFileInput = (e) => {
    setSelectedFile(e.target.files[0]);
  };
  const handleUpload = async (file) => {
    // Function to upload file to s3
    // S3 Bucket Name

    // S3 Credentials
    AWS.config.update({
      accessKeyId: ACCESS_KEY,
      secretAccessKey: SECRET_ACCESS_KEY,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    // Files Parameters

    const params = {
      Bucket: S3_BUCKET,
      Key: file.name,
      Body: file,
    };

    // Uploading file to s3

    const upload = s3
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        // File uploading progress
        console.log(`Uploading ${parseInt((evt.loaded * 100) / evt.total)}%`);
      })
      .promise();

    await upload.then((err, data) => {
      console.log(err);
      // Fille successfully uploaded
      alert("File uploaded successfully.");
    });
  };
  const handleModifyRiskDetails = async (id) => {
    const sc0 = scenarios[0] || {};
    const sc1 = scenarios[1] || {};
    const requestBody = {
      Title: RiskDetails.Title,
      Description: RiskDetails.Description,
      Category: selectedCategory || RiskDetails.Category,
      SubCategory: selectedSubCategory || RiskDetails.SubCategory,
      timeFrame,
      likelihood, // ID172
      linkedHorizonTheme,
      // ID171 — overall Plausibility description (risk-level, not per-scenario)
      plausibilityDescription,
      // ID98 — single overall Time Horizon & Velocity applied to every scenario field
      scenarios: scenarios.map((sc) => ({ ...sc, velocity: overallVelocity })),
      baseVelocity: overallVelocity,
      optimisticVelocity: overallVelocity,
      optimisticThreatOpp: sc0.threatOpp || "loss",
      optimisticConsequenceAmt: sc0.consequenceAmt || "",
      optimisticQualitative: sc0.qualitative || "",
      optimisticConsequenceType: sc0.consequenceType || "",
      optimisticResponseStatus: sc0.responseStatus || "",
      pessimisticVelocity: overallVelocity,
      pessimisticThreatOpp: sc1.threatOpp || "loss",
      pessimisticConsequenceAmt: sc1.consequenceAmt || "",
      pessimisticQualitative: sc1.qualitative || "",
      pessimisticConsequenceType: sc1.consequenceType || "",
      pessimisticResponseStatus: sc1.responseStatus || "",
    };
    try {
      const res = await execute(
        "PUT",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/update/${id}`,
        requestBody
      );
      if (res?.success === false) {
        // eslint-disable-next-line no-alert
        alert(res?.message || "Failed to save risk details.");
        return false;
      }
      // Reflect the saved scenarios back into state so a later edit/reload is consistent.
      if (res?.data?.scenarios) setScenarios(res.data.scenarios);
      setReload((r) => !r);
      return true;
    } catch {
      // eslint-disable-next-line no-alert
      alert("Failed to save risk details.");
      return false;
    }
  };

  const doActivate = (id, acknowledged) => {
    execute(
      "PATCH",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/activate/${id}`,
      acknowledged ? { acknowledged: true } : {}
    )
      .then((res) => {
        if (res?.success === false) {
          // eslint-disable-next-line no-alert
          alert(res?.message || "Could not publish this risk.");
        } else if (res?.data) {
          setRiskDetails((prev) => ({ ...prev, status: res.data.status }));
        }
        setReload((r) => !r);
      })
      .catch(() => {});
  };

  const handleActivateRisk = (id, currentStatus) => {
    // Publishing (draft → active) requires the tick-to-confirm disclaimer; un-publishing does not.
    // currentStatus is the status of THIS record (a list row passes item.status; the detail view
    // falls back to the open record's status).
    const status = currentStatus != null ? currentStatus : RiskDetails.status;
    if (status !== "active") {
      setPendingActivateId(id);
      setPublishAck(false);
      setPublishConfirmOpen(true);
      return;
    }
    doActivate(id, false);
  };

  const confirmPublish = () => {
    if (!publishAck || !pendingActivateId) return;
    setPublishConfirmOpen(false);
    doActivate(pendingActivateId, true);
    setPendingActivateId(null);
  };

  // Mirrors the (now relaxed) backend validateForPublish (api/controllers/emergingRisk.js): a risk can
  // be published with a Title alone — everything else is optional and can be enriched later. The only
  // other publish gate is the tick-to-confirm disclaimer, handled at the Activate button.
  const getPublishMissing = () => {
    const missing = [];
    if (String(RiskDetails.Title || "").trim().length < 5)
      missing.push("Title (at least 5 characters)");
    return missing;
  };

  // ID96 Ph3 — owner/delegate accepts the AI position or moves the radar ball.
  // Pass proximity = null to clear the override and revert to the AI position.
  const setManualBallPosition = (proximity) => {
    const id = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    if (!id) return;
    execute(
      "PUT",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/${id}/overall-trend/manual`,
      { proximity }
    )
      .then((res) => {
        if (res?.data) {
          setRiskDetails((prev) => ({ ...prev, overallSignalTrend: res.data }));
          // ID197 — reflect the new ball position immediately (no reopen needed): the shaped
          // radar risk drives the "Where it sits" gauge + Trending value, so sync its proximity to
          // the manual override (or back to the AI proximity when reverted).
          setRadarRisk((prev) =>
            prev
              ? {
                  ...prev,
                  signpostProximity:
                    typeof res.data.manualProximity === "number"
                      ? res.data.manualProximity
                      : res.data.proximity ?? prev.signpostProximity,
                }
              : prev
          );
        }
      })
      .catch(() => {});
  };

  // Save one signpost's draft (thresholds). Returns a promise so we can save them all together.
  const handleSaveSignpost = (spId, draft) =>
    execute(
      "PUT",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/signposts/${spId}`,
      draft
    )
      .then((res) => {
        if (res?.data) {
          setActiveSignposts((prev) =>
            prev.map((sp) => (String(sp._id || sp.id) === spId ? { ...sp, ...res.data } : sp))
          );
        }
      })
      .catch(() => {});

  // Mutate one signpost's draft in the per-id drafts map.
  const updateSpDraft = (spId, updater) =>
    setEditingSpDrafts((m) => {
      const cur = m[spId] || { thresholds: [] };
      return { ...m, [spId]: updater(cur) };
    });

  // UAT feedback: stop making users guess thresholds. Ask the API to derive optimistic/pessimistic
  // from the signpost's own history (moving average ± 2σ + seasonality) and pre-fill the fields.
  const MONTH_ABBR = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [spSuggestNote, setSpSuggestNote] = useState({}); // spId -> caption string
  const [spSuggestBusy, setSpSuggestBusy] = useState({}); // spId -> bool
  const suggestThresholdsFor = (sp) => {
    const spId = String(sp._id || sp.id);
    setSpSuggestBusy((m) => ({ ...m, [spId]: true }));
    setSpSuggestNote((m) => ({ ...m, [spId]: "" }));
    executeRef
      .current(
        "GET",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/signposts/${spId}/suggest-thresholds`
      )
      .then((res) => {
        const s = res?.data;
        if (!s || !s.suggested) {
          setSpSuggestNote((m) => ({
            ...m,
            [spId]:
              s && s.count != null
                ? `Not enough history yet (${s.count} data point${
                    s.count === 1 ? "" : "s"
                  }) — a few more are needed.`
                : "No suggestion available yet.",
          }));
          return;
        }
        // Apply the suggested values into the draft, matching existing rows by scenario (or adding).
        updateSpDraft(spId, (d) => {
          const base = d.thresholds && d.thresholds.length ? d.thresholds : sp.thresholds || [];
          const ts = base.map((t) => ({ ...t }));
          s.suggested.forEach((sug) => {
            const label =
              sug.scenario === "pessimistic"
                ? "Worst Case"
                : sug.scenario === "optimistic"
                ? "Best Case"
                : "";
            const idx = ts.findIndex((t) => t.scenario === sug.scenario);
            if (idx === -1) {
              ts.push({
                scenario: sug.scenario,
                scenarioLabel: label,
                direction: sug.direction,
                value: sug.value,
              });
            } else {
              ts[idx] = { ...ts[idx], direction: sug.direction, value: sug.value };
            }
          });
          return { ...d, thresholds: ts };
        });
        const seas =
          s.seasonality && s.seasonality.detected
            ? ` · seasonal (peak ${MONTH_ABBR[s.seasonality.peakMonth] || "?"})`
            : "";
        setSpSuggestNote((m) => ({
          ...m,
          [spId]: `From ${s.count} data points: mean ${s.mean} ± 2σ → range ${s.bands.lower2}–${s.bands.upper2} · ${s.trend.direction} ${s.trend.pctChange}%${seas}. Applied as a starting point — adjust as needed.`,
        }));
      })
      .catch(() => setSpSuggestNote((m) => ({ ...m, [spId]: "Could not compute a suggestion." })))
      .finally(() => setSpSuggestBusy((m) => ({ ...m, [spId]: false })));
  };

  const handleDeleteSignpost = (spId) => {
    if (!window.confirm("Delete this signpost?")) return;
    execute("DELETE", `${protectedResources.apiTodoList.endpoint}/emergingRisk/signposts/${spId}`)
      .then(() => {
        setActiveSignposts((prev) => prev.filter((sp) => String(sp._id || sp.id) !== spId));
        setEditingSpDrafts((m) => {
          const next = { ...m };
          delete next[spId];
          return next;
        });
      })
      .catch(() => {});
  };

  // When edit mode turns on, seed an editable threshold draft for every signpost so they
  // are all immediately editable (mirrors the top "Edit" toggle).
  useEffect(() => {
    if (!editMode) {
      setEditingSpDrafts({});
      return;
    }
    setEditingSpDrafts((m) => {
      const next = { ...m };
      activeSignposts.forEach((sp) => {
        const id = String(sp._id || sp.id);
        if (!next[id]) {
          next[id] = {
            name: sp.name || "",
            desc: sp.desc || "",
            thresholds: sp.thresholds ? JSON.parse(JSON.stringify(sp.thresholds)) : [],
          };
        }
      });
      return next;
    });
  }, [editMode, activeSignposts]);

  // The auto per-risk "Risk Horizon Scan" is a special qualitative signpost — surface it as its own
  // "Themes for this risk" panel, and keep it OUT of the normal signpost list/chart.
  const riskHorizonSp = activeSignposts.find((sp) => sp.scanKind === "risk_horizon") || null;
  const normalSignposts = activeSignposts.filter((sp) => sp.scanKind !== "risk_horizon");

  // Seed the user-scan-focus input from the stored signpost once.
  useEffect(() => {
    if (riskHorizonSp && !horizonQuerySeeded.current) {
      horizonQuerySeeded.current = true;
      setHorizonQuery(riskHorizonSp.userScanQuery || "");
    }
  }, [riskHorizonSp]);

  // Run the risk horizon scan (synchronous server-side), optionally with the user's focus query.
  const rescanRiskHorizon = () => {
    if (!riskHorizonSp || horizonScanning) return;
    const spId = String(riskHorizonSp._id || riskHorizonSp.id);
    setHorizonScanning(true);
    execute(
      "POST",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/signposts/${spId}/horizon-rescan`,
      { query: horizonQuery }
    )
      .then(() => setReload((r) => !r))
      .catch(() => {})
      .finally(() => setHorizonScanning(false));
  };

  // Remove a theme from this risk's Horizon Scan. Persisted server-side so a rescan won't re-add it.
  const hideHorizonTheme = (themeName) => {
    if (!riskHorizonSp || !themeName) return;
    const spId = String(riskHorizonSp._id || riskHorizonSp.id);
    execute(
      "POST",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/signposts/${spId}/horizon-themes/hide`,
      { theme: themeName }
    )
      .then((res) => {
        if (res?.data) {
          setActiveSignposts((prev) =>
            prev.map((sp) => (String(sp._id || sp.id) === spId ? res.data : sp))
          );
        }
      })
      .catch(() => {});
  };

  // Reset the one-shot guards whenever a different risk is opened.
  useEffect(() => {
    horizonAutoRef.current = false;
    horizonQuerySeeded.current = false;
    setGenDismissed(false); // re-show the generating overlay for a newly opened risk
  }, [RiskDetails.id]);

  // If the risk-horizon signpost exists but has never been scanned (the fire-and-forget create scan
  // didn't land), run it once automatically the first time the risk is opened.
  useEffect(() => {
    if (
      riskHorizonSp &&
      !riskHorizonSp.horizonScannedAt &&
      !horizonScanning &&
      !horizonAutoRef.current
    ) {
      horizonAutoRef.current = true;
      rescanRiskHorizon();
    }
  }, [riskHorizonSp]);

  // AI-populate both scenarios (Best/Worst) with consequence type+level and the overall likelihood,
  // grounded in the company context + the tenant's evaluation criteria.
  const populateWithAI = () => {
    if (aiPopulating) return undefined;
    const cat = selectedCategory || RiskDetails.Category || "";
    const subCat = selectedSubCategory || RiskDetails.SubCategory || "";
    if (!String(RiskDetails.Title || "").trim() && !String(RiskDetails.Description || "").trim()) {
      // eslint-disable-next-line no-alert
      alert("Add a title or description first, then Populate with AI.");
      return undefined;
    }
    setAiPopulating(true);
    return execute(
      "POST",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/suggest-assessment`,
      {
        title: RiskDetails.Title || "",
        description: RiskDetails.Description || "",
        category: cat,
        subCategory: subCat,
      }
    )
      .then((res) => {
        const d = res?.data;
        if (!d) return;
        if (d.likelihood) {
          if (isLikelihoodMode) setLikelihood(d.likelihood);
          else setOverallVelocity(d.likelihood);
        }
        if (Array.isArray(d.scenarios) && d.scenarios.length) {
          setScenarios((prev) => {
            const next = prev.map((s) => ({ ...s }));
            d.scenarios.forEach((sug, i) => {
              if (!next[i]) return;
              if (sug.threatOpp) next[i].threatOpp = sug.threatOpp;
              const cons = Array.isArray(sug.consequences) ? sug.consequences : [];
              if (cons.length) {
                next[i].consequences = cons.map((c) => ({ type: c.type, level: c.level }));
                next[i].consequenceType = cons[0].type;
                next[i].qualitative = cons[0].level;
                next[i].consequenceMode = "qualitative";
              }
            });
            return next;
          });
        }
      })
      .catch(() => {})
      .finally(() => setAiPopulating(false));
  };

  // Arriving via "Advance to Watchlist": auto-run the AI populate once so the risk lands with both
  // scenarios + likelihood already assessed from the theme + company context.
  useEffect(() => {
    if (
      horizonPrefill &&
      !aiAutoRef.current &&
      String(RiskDetails.Title || "").trim() &&
      !aiPopulating
    ) {
      aiAutoRef.current = true;
      setAdvancing(true); // start the one-shot overlay (assessing → saving → scanning)
      phase3RanRef.current = false;
      // Run the AI populate, then flag for auto-save (whether AI succeeds or fails) so the advanced
      // theme is persisted with its assessment without the user having to click Save.
      Promise.resolve(populateWithAI()).finally(() => setAutoSavePending(true));
    }
  }, [horizonPrefill, RiskDetails.Title]);

  // Auto-save on advance: once the AI assessment has settled (aiPopulating false) and the scenarios
  // are in state, create the draft once via the latest postRiskData (ref avoids stale scenarios).
  useEffect(() => {
    if (!autoSavePending || aiPopulating || autoSavedRef.current) return;
    setAutoSavePending(false);
    if (RiskDetails.id || RiskDetails._id) return; // already saved — nothing to do
    autoSavedRef.current = true;
    setAdvanceSaving(true);
    Promise.resolve(postRiskDataRef.current && postRiskDataRef.current()).finally(() =>
      setAdvanceSaving(false)
    );
  }, [autoSavePending, aiPopulating]);

  // End the advance overlay once the horizon scan has produced themes, or finished (even with none —
  // either the client scan ran, or the server's create-time scan already completed).
  useEffect(() => {
    if (!advancing) return;
    if ((riskHorizonSp?.horizonThemes || []).length > 0) {
      setAdvancing(false);
      return;
    }
    if (horizonScanning) {
      phase3RanRef.current = true;
      return;
    }
    if (phase3RanRef.current || (riskHorizonSp && riskHorizonSp.horizonScannedAt))
      setAdvancing(false);
  }, [advancing, horizonScanning, riskHorizonSp]);

  // Save risk details + every signpost's threshold edits in one go (top "Save").
  const handleSaveAll = async () => {
    const id = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    await handleModifyRiskDetails(id);
    await Promise.all(
      activeSignposts.map((sp) => {
        const sid = String(sp._id || sp.id);
        const draft = editingSpDrafts[sid];
        if (!draft) return Promise.resolve();
        return handleSaveSignpost(sid, draft);
      })
    );
    setEditingSpDrafts({});
  };

  // Open the styled delete warning (replaces the old native window.confirm) — the actual delete runs
  // only when the user confirms in the dialog.
  const handleDeleteRiskDetails = () => setDeleteDialogOpen(true);
  const performDeleteRisk = (id) => {
    if (!id) return;
    setDeleteDialogOpen(false);
    try {
      execute(
        "DELETE",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/delete/${id}`
      ).then(() => {
        setShowSignPost(false);
        setReload((r) => !r);
        setCreateRisk(false);
      });
    } catch {
      /* empty */
    }
  };
  // ── Lifecycle: archive / restore (soft close, retained + restorable) ──────────
  const loadArchived = () => {
    execute("GET", `${protectedResources.apiTodoList.endpoint}/emergingRisk/list?status=archived`)
      .then((res) => setArchivedRisks(Array.isArray(res?.data) ? res.data : []))
      .catch(() => setArchivedRisks([]));
  };
  // ID195 — fetch the archived count up front so the "Show archived" toggle advertises itself
  // (e.g. "Show archived (3)") and users can find where to restore closed risks.
  useEffect(() => {
    executeRef
      .current(
        "GET",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/list?status=archived`
      )
      .then((res) => setArchivedRisks(Array.isArray(res?.data) ? res.data : []))
      .catch(() => {});
  }, []);
  const handleArchiveRisk = (id, reason) => {
    if (!id || !reason) return;
    setArchiveDialogOpen(false);
    setArchiveReasonText("");
    execute("PATCH", `${protectedResources.apiTodoList.endpoint}/emergingRisk/archive/${id}`, {
      reason,
    })
      .then(() => {
        setShowSignPost(false);
        setCreateRisk(false);
        setReload((r) => !r);
        if (showArchived) loadArchived();
      })
      .catch(() => {});
  };
  // ID195 — step 1: clicking Restore opens a confirmation dialog (does not restore immediately).
  const requestRestore = (risk) => {
    if (!risk) return;
    setRestoreTarget(risk);
    setRestoreDialogOpen(true);
  };
  // ID195 — step 2: on OK, restore the risk (backend lands it in draft) then open its full record
  // so the user can verify and re-publish it.
  const handleRestoreRisk = () => {
    const risk = restoreTarget;
    const id = risk?.id || (risk?._id && String(risk._id));
    if (!id) return;
    setRestoreDialogOpen(false);
    execute("PATCH", `${protectedResources.apiTodoList.endpoint}/emergingRisk/restore/${id}`)
      .then(() => {
        setReload((r) => !r);
        loadArchived();
        setShowArchived(false);
        // Open the restored record in draft stage (restore always returns a risk to draft).
        handleSignPost({ ...risk, id, status: "draft" });
        setRestoreTarget(null);
      })
      .catch(() => {});
  };

  // ID195 — the archived-risks panel (with Restore). The "Show archived" toggle sits next to
  // "Show drafts" in the radar toolbar; this panel renders just below it when toggled on.
  const renderArchivedPanel = () =>
    showArchived ? (
      <MDBox
        sx={{
          mx: 2,
          mb: 1.5,
          p: 1.5,
          border: "1px solid #e7e2ef",
          borderRadius: 2,
          bgcolor: "#faf9fc",
        }}
      >
        <MDTypography variant="caption" fontWeight="bold" sx={{ color: "#6a6478" }}>
          Archived risks ({archivedRisks.length})
        </MDTypography>
        {archivedRisks.length === 0 ? (
          <MDTypography variant="caption" sx={{ display: "block", mt: 0.5 }} color="text.secondary">
            No archived risks.
          </MDTypography>
        ) : (
          archivedRisks.map((ar) => (
            <MDBox
              key={ar._id || ar.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                py: 0.5,
                borderBottom: "1px solid #efeaf6",
              }}
            >
              <MDTypography variant="caption" sx={{ flex: 1 }}>
                {ar.Title || "(untitled risk)"}
                {ar.closedReason ? (
                  <span style={{ color: "#8a6300" }}> · {ar.closedReason}</span>
                ) : null}
              </MDTypography>
              <MDButton
                size="small"
                variant="text"
                startIcon={<RestoreIcon fontSize="small" />}
                sx={{ color: "#2c7a50" }}
                onClick={() => requestRestore(ar)}
              >
                Restore
              </MDButton>
            </MDBox>
          ))
        )}
      </MDBox>
    ) : null;

  // ── Commentary (append-only trail on the risk; AI entries auto-append server-side) ────────────
  const handleAddComment = () => {
    const id = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    const text = commentInput.trim();
    if (!id || !text) return;
    execute("POST", `${protectedResources.apiTodoList.endpoint}/emergingRisk/${id}/commentary`, {
      text,
    })
      .then((res) => {
        if (res?.data) setRiskDetails((prev) => ({ ...prev, commentary: res.data }));
        setCommentInput("");
      })
      .catch(() => {});
  };
  const handleDeleteComment = (commentId) => {
    const id = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    if (!id || !commentId) return;
    execute(
      "DELETE",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/${id}/commentary/${commentId}`
    )
      .then((res) => {
        if (res?.data) setRiskDetails((prev) => ({ ...prev, commentary: res.data }));
      })
      .catch(() => {});
  };
  //
  const handleSignPost = (item) => {
    // ID89 — tabs are merged, so open the full risk details (scenarios + category load too).
    const normalizedItem = { ...item, id: item.id || (item._id && String(item._id)) };
    setRiskDetails(normalizedItem);
    setSelectedCategory(item.Category || "");
    setSelectedSubCategory(item.SubCategory || "");
    setTimeFrame(item.timeFrame || "medium-term");
    setLikelihood(item.likelihood || "");
    setLinkedHorizonTheme(item.linkedHorizonTheme || "");
    const matched = allSubCats.find((s) => s.Category === item.Category);
    if (matched) setSubCategories(matched.SubCategory || []);
    loadScenariosFromRisk(normalizedItem);
    setCreateRisk(false);
    setShowSignPost(true);
    setEditMode(false);
    setJustCreated(false);
  };
  const handleScenarioChange = (event, newValue) => {
    setScenario(newValue);
  };
  const handleSelectSignPost = (event, label, newValue) => {
    console.log(newValue);
    console.log("Risk Cate id here", RiskDetails.id);
    setSelectedSignPost(newValue);
    setSignPost({});
    // setType(event.target.value);
    setSignPost((prevState) => ({
      ...prevState,
      type: label,
    }));
    setSignPost((prevState) => ({
      ...prevState,
      riskCategoryId: RiskDetails.id,
    }));
    /* setSignPost((prevState) => ({
      ...prevState,
      desc: label,
    })); */
    setSignPost((prevState) => ({
      ...prevState,
      typeValue: newValue,
    }));
    console.log(SignPost);
  };
  //
  // useEffect to initialize the state once TableData is available
  // handle input change for editing row
  // const [validationErrors, setValidationErrors] = useState({});
  const [, setEditObject] = useState(null);
  // add new appetite
  // const [isSuccess, setisSuccess] = useState(false);
  // const validateRequired = (value) => !!value.length;
  const [formErrors, setFormErrors] = useState({
    Title: "",
    Description: "",
    Taxo_curr: "",
    baseConsequenceAmt: "",
    baseVelocity: "",
    baseQualitative: "",
  });
  const radarconfig = {
    displayModeBar: false,
    responsive: true,
    displaylogo: false,
  };
  useEffect(() => {
    const run = executeRef.current;
    const labels = [];
    setRadardata([]);
    run("GET", `${protectedResources.apiTodoList.endpoint}/getAllCategoriesSubCategories`).then(
      (response) => {
        if (response) {
          const arr = Array.isArray(response) ? response : response.data || [];
          setAllSubCats(arr);
          arr.forEach((item) => labels.push(item.Category));
          // Fetch horizon themes for the linkedHorizonTheme picker
          run(
            "GET",
            `${protectedResources.apiTodoList.endpoint}/anticipateHorizonScan/theme-overview`
          )
            .then((themeRes) => {
              const themes = themeRes?.data?.themes || [];
              setHorizonThemes(themes.map((t) => t.themeLabel || t.themeKey || "").filter(Boolean));
            })
            .catch(() => {});
          run("GET", `${protectedResources.apiTodoList.endpoint}/evaluation-criteria/config`)
            .then((criRes) => {
              const data = criRes?.data ?? criRes ?? {};
              setEvalCriteria({
                plausibilityRows: data?.plausibilityTable?.rows ?? [],
                likelihoodRows: data?.likelihoodTable?.rows ?? [],
                consequenceLevels: data?.consequenceTable?.levels ?? [],
                consequenceRows: data?.consequenceTable?.rows ?? [],
                prioritisationMatrix: data?.prioritisationMatrix ?? null, // ID54 residual picker
                plausibilityMode:
                  data?.plausibilityMode === "likelihood" ? "likelihood" : "timeframe_velocity",
              });
            })
            .catch(() => {});
          // If arriving from horizon scan prefill, populate subCategories for the prefilled L1
          if (horizonPrefill?.category) {
            const matched = arr.find((item) => item.Category === horizonPrefill.category);
            if (matched) setSubCategories(matched.SubCategory || []);
          }

          run("GET", `${protectedResources.apiTodoList.endpoint}/emergingRisk/list`).then(
            (riskResponse) => {
              if (riskResponse?.data && riskResponse.data.length > 0) {
                const radarvalues = [];
                const traces = [];
                let r = [];
                let theta = [];
                let marker = {};
                riskResponse.data.forEach((item, index) => {
                  r = [];
                  theta = [];
                  marker = {};
                  if (scenario === "Base") {
                    if (item.baseVelocity === "Near Term + High") {
                      r.push(50 + index * 5);
                      // theta.push(90 + index * 10);
                    } else if (item.baseVelocity === "Near Term + Low") {
                      r.push(50 - index * 5);
                      // theta.push(210 + index * 10);
                    } else if (item.baseVelocity === "Long Term + High") {
                      r.push(150 + index * 5);
                      // theta.push(190 + index * 10);
                    } else if (item.baseVelocity === "Long Term + Low") {
                      r.push(150 - index * 5);
                      // theta.push(100 + index * 10);
                    }
                    if (item.baseThreatOpp === "gain")
                      theta.push(labels.indexOf(item.Category) * 18);
                    else theta.push(180 + labels.indexOf(item.Category) * 18);
                  } else if (scenario === "Pessimistic") {
                    if (item.pessimisticVelocity === "Near Term + High") {
                      r.push(50 + index * 5);
                      // theta.push(90 + index * 10);
                    } else if (item.pessimisticVelocity === "Near Term + Low") {
                      r.push(50 - index * 5);
                      // theta.push(210 + index * 10);
                    } else if (item.pessimisticVelocity === "Long Term + High") {
                      r.push(150 + index * 5);
                      // theta.push(190 + index * 10);
                    } else if (item.pessimisticVelocity === "Long Term + Low") {
                      r.push(150 - index * 5);
                      // theta.push(100 + index * 10);
                    }
                    if (item.pessimisticThreatOpp === "gain")
                      theta.push(labels.indexOf(item.Category) * 18);
                    else theta.push(180 + labels.indexOf(item.Category) * 18);
                  } else if (scenario === "Optimistic") {
                    if (item.optimisticVelocity === "Near Term + High") {
                      r.push(50 + index * 5);
                      // theta.push(90 + index * 10);
                    } else if (item.optimisticVelocity === "Near Term + Low") {
                      r.push(50 - index * 5);
                      // theta.push(210 + index * 10);
                    } else if (item.optimisticVelocity === "Long Term + High") {
                      r.push(150 + index * 5);
                      // theta.push(190 + index * 10);
                    } else if (item.optimisticVelocity === "Long Term + Low") {
                      r.push(150 - index * 5);
                      // theta.push(100 + index * 10);
                    }
                    if (item.optimisticThreatOpp === "gain")
                      theta.push(labels.indexOf(item.Category) * 18);
                    else theta.push(180 + labels.indexOf(item.Category) * 18);
                  }

                  // Generate random size between 10 and 30 for circle markers
                  const randomSize = Math.floor(Math.random() * (30 - 10 + 1)) + 10;

                  if (item.baseResponseStatus === "Prepared and Tested") {
                    marker = {
                      symbol:
                        "M 0 -6 A 6 6 0 1 1 0 6 A 6 6 0 1 1 0 -6 Z M 0 -9 A 9 9 0 1 0 0 9 A 9 9 0 1 0 0 -9 Z",
                      color: "#D6B70A",
                      size: randomSize,
                    };
                  } else {
                    marker = {
                      symbol:
                        "M 0 -6 A 6 6 0 1 1 0 6 A 6 6 0 1 1 0 -6 Z M 0 -9 A 9 9 0 1 0 0 9 A 9 9 0 1 0 0 -9 Z",
                      color: "green",
                      size: randomSize,
                    };
                  }

                  traces.push({
                    type: "scatterpolar",
                    mode: "markers",
                    r,
                    theta,
                    hoverinfo: "text",
                    hovertext: `Risk Details: ${item.Title}`,
                    marker,
                  });
                  radarvalues.push(item.baseConsequenceAmt);
                });
                setRadardata(traces);
                setRiskDetailsData(riskResponse.data);
                setRadarOptions({
                  polar: {
                    radialaxis: {
                      tickvals: [0, 50, 100, 150, 200], // Adjust these values based on your categories
                      ticktext: ["Current", "Near Term", "Mid Term", "Long Term", "Distant"],
                      angle: 90, // Rotate the radial axis to align with the straight line
                      tickangle: "90", // Automatically adjust tick angles
                      tickmode: "array",
                      tickfont: {
                        size: 10,
                      },
                    },
                    angularaxis: {
                      tickvals: [
                        0, 18, 36, 54, 72, 90, 108, 126, 144, 162, 180, 198, 216, 234, 252, 270,
                        288, 306, 324, 342,
                      ], // Adjust these values based on your categories
                      ticktext: labels,
                      categoryorder: "array",
                      tickmode: "array",
                      tickangle: "0", // Automatically adjust tick angles
                      tickfont: {
                        size: 10,
                      },
                    },
                  },
                  showlegend: false,
                  width: 800, // Adjust the width of the chart
                  height: 600, // Adjust the height of the chart
                  annotations: [
                    {
                      text: "OPPORTUNITY",
                      x: 0.5,
                      y: 1.2,
                      xref: "paper",
                      yref: "paper",
                      showarrow: false,
                      font: {
                        size: 16,
                      },
                    },
                    {
                      text: "THREAT",
                      x: 0.5,
                      y: -0.2,
                      xref: "paper",
                      yref: "paper",
                      showarrow: false,
                      font: {
                        size: 16,
                      },
                    },
                  ],
                });
                /*         setRadardata([
          {
            type: "scatterpolar",
            mode: "markers",
            r: [50, 80],
            theta: [90, 210],
            hoverinfo: "text",
            hovertext: "<a href='https://example.com' target='_blank'>Click me!</a>",
            marker: {
              symbol:
                "M 0 -6 A 6 6 0 1 1 0 6 A 6 6 0 1 1 0 -6 Z M 0 -9 A 9 9 0 1 0 0 9 A 9 9 0 1 0 0 -9 Z",
              color: "#D6B70A",
              size: 20,
            },
          },
          {
            type: "scatterpolar",
            mode: "markers",
            r: [120, 170, 200],
            theta: [330, 100, 150],
            hovertext: "text",
            marker: {
              symbol:
                "M 0 -6 A 6 6 0 1 1 0 6 A 6 6 0 1 1 0 -6 Z M 0 -9 A 9 9 0 1 0 0 9 A 9 9 0 1 0 0 -9 Z",
              color: "green",
              size: 20,
            },
          },
        ]); */
              } else {
                setRadardata([]);
                setRiskDetailsData(riskResponse?.data ?? []);
              }
            }
          );
        }
      }
    );
  }, [createRisk, scenario, reload]);

  // ID154 — when navigated here from a Horizon Scan theme's ⚑ Watchlist flag, open that risk's
  // details automatically once the list has loaded, then clear the nav state so a refresh / back
  // doesn't re-trigger it.
  const openedRiskRef = useRef(false);
  useEffect(() => {
    const openId = location.state?.openRiskId;
    if (!openId || openedRiskRef.current) return;
    if (!Array.isArray(riskDetailsData) || riskDetailsData.length === 0) return;
    const match = riskDetailsData.find((r) => String(r._id || r.id) === String(openId));
    if (match) {
      openedRiskRef.current = true;
      handleSignPost(match);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [riskDetailsData, location.state, location.pathname, navigate]);

  // Load signpost library entries once on mount
  useEffect(() => {
    const run = executeRef.current;
    run("GET", `${protectedResources.apiTodoList.endpoint}/signpostLibrary/list`)
      .then((res) => {
        const list = res?.data ?? [];
        setSignpostLibraryList(Array.isArray(list) ? list : []);
      })
      .catch(() => {});
  }, []);

  // Load signposts when switching to the Sign Posts tab for a specific risk
  useEffect(() => {
    // ID89 — merged view always shows signposts, so load whenever the panel is open.
    if (!showSignPost || !RiskDetails.id) return;
    const run = executeRef.current;
    setSignpostsLoading(true);
    run(
      "GET",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/${RiskDetails.id}/signposts`
    )
      .then((res) => {
        const list = res?.data ?? [];
        setActiveSignposts(Array.isArray(list) ? list : []);
      })
      .catch(() => setActiveSignposts([]))
      .finally(() => setSignpostsLoading(false));
  }, [showSignPost, RiskDetails.id, reload]);

  // Phase 3 — ask the design agent to propose signposts for this risk (read-only), then let the
  // user pick which to create. Defaults to selecting all proposals.
  const openSuggestSignposts = (ridArg) => {
    // Guard: when wired directly to onClick, React passes the event object here — only accept a
    // string id, otherwise fall back to the loaded risk's id.
    const rid = (typeof ridArg === "string" && ridArg) || RiskDetails.id || RiskDetails._id;
    if (!rid) return;
    setSuggestOpen(true);
    setSuggestLoading(true);
    setSuggestions(null);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/${rid}/suggest-signposts`,
        {}
      )
      .then((res) => {
        const d = res?.data || null;
        setSuggestions(d);
        const pq = {};
        (d?.quantitative || []).forEach((_, i) => {
          pq[i] = true;
        });
        setPickQuant(pq);
        // Suggestions are now QUANTITATIVE ONLY — qualitative signals are covered by the risk's
        // linked Horizon Scan theme, so qualitative triggers are neither pre-selected nor offered.
      })
      .catch(() => setSuggestions({ error: true }))
      .finally(() => setSuggestLoading(false));
  };

  // Create the user-approved subset. Nothing is written until this runs.
  const createSelectedSignposts = () => {
    const rid = RiskDetails.id || RiskDetails._id;
    if (!rid || !suggestions) return;
    const quantitative = (suggestions.quantitative || []).filter((_, i) => pickQuant[i]);
    // Quantitative-only: qualitative trigger-events are no longer created from suggestions (the
    // risk's linked Horizon Scan theme covers qualitative signals). Always send an empty list.
    const qualitativeTriggers = [];
    if (quantitative.length === 0 && qualitativeTriggers.length === 0) return;
    setCreatingSp(true);
    executeRef
      .current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/${rid}/create-signposts`,
        { quantitative, qualitativeTriggers, qualitativeSummary: suggestions.summary || "" }
      )
      .then(() => {
        // Show a confirmation of what was created + the suggested thresholds, so the user consciously
        // reviews them (and can adjust below) rather than the dialog just vanishing.
        setConfirmSpList(quantitative);
        setSuggestOpen(false);
        setConfirmSpOpen(true);
        setReload((r) => !r); // refresh the signpost list below
      })
      .catch(() => {})
      .finally(() => setCreatingSp(false));
  };

  // ID88 — load this risk's attachments whenever the details panel opens.
  // Also (re)load the authoritative scenarios from the full record here. The list/radar item used
  // to open the panel can omit the scenarios array, which would otherwise trigger the legacy
  // fallback and show a details-less "Base Case". We skip this while editing so we don't clobber
  // unsaved edits.
  useEffect(() => {
    if (!showSignPost || !RiskDetails.id) {
      setAttachments([]);
      return;
    }
    const run = executeRef.current;
    run("GET", `${protectedResources.apiTodoList.endpoint}/emergingRisk/${RiskDetails.id}`)
      .then((res) => {
        const data = res?.data || {};
        setAttachments(Array.isArray(data.attachments) ? data.attachments : []);
        if (!editMode && Array.isArray(data.scenarios) && data.scenarios.length > 0) {
          setScenarios(data.scenarios);
        }
        // ID171 — keep the overall Plausibility description in sync with the saved record.
        if (!editMode && data.plausibilityDescription !== undefined) {
          setPlausibilityDescription(data.plausibilityDescription || "");
        }
      })
      .catch(() => setAttachments([]));
  }, [showSignPost, RiskDetails.id, reload, editMode]);

  const validateRiskDetailsFields = () => {
    let isValid = true;
    const errors = {};

    if (!RiskDetails.Title) {
      isValid = false;
      errors.Title = "Title is required";
    }

    // Taxonomy L1/L2 are mandatory (PO 2026-10-16) — an uncategorised risk can't be placed on the
    // home taxonomy grid, so it must have both a Category and a Sub-category.
    const catVal = selectedCategory || RiskDetails.Category;
    const subVal = selectedSubCategory || RiskDetails.SubCategory;
    if (!catVal) {
      isValid = false;
      errors.Category = "Category is required";
    } else if (!subVal) {
      isValid = false;
      errors.SubCategory = "Sub-category is required";
    }

    // ID196 — Likelihood (plausibility) is mandatory.
    const likeVal = isLikelihoodMode ? likelihood : overallVelocity;
    if (!likeVal) {
      isValid = false;
      errors.likelihood = isLikelihoodMode ? "Likelihood is required" : "Plausibility is required";
    }

    setFormErrors(errors);
    return isValid;
  };
  const handleSignPostsChange = (event) => {
    const { name, value } = event.target;
    console.log(name, value);
    setSignPost((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log("SignPost", SignPost);
  };
  const handleRiskDetailsChange = (event) => {
    const { name, value } = event.target;
    console.log(name, value);
    setRiskDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(RiskDetails);
  };
  const handleNext = () => {
    let isValid = true;

    if (activeStep === 0) {
      isValid = validateRiskDetailsFields();
    }

    if (activeStep === 1) {
      isValid = validateRiskDetailsFields();
    }

    if (isValid) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
    const selectedData = allSubCats.find((item) => item.Category === newValue);
    if (selectedData) {
      setSubCategories(selectedData.SubCategory);
      setSelectedSubCategory();
    } else {
      setSubCategories([]);
    }
  };
  const handleSubCategoryChange = (event, newValue) => {
    setSelectedSubCategory(newValue);
  };
  // ID78 — pick a (Category, SubCategory) pair from the full-taxonomy pop-up in one click.
  const handleTaxonomyPick = (cat, sub) => {
    setSelectedCategory(cat);
    const selectedData = allSubCats.find((item) => item.Category === cat);
    setSubCategories(selectedData ? selectedData.SubCategory : []);
    setSelectedSubCategory(sub);
    setTaxPickerOpen(false);
    setTaxSearch("");
  };
  const openTaxonomyPicker = () => {
    setTaxExpanded(selectedCategory || null);
    setTaxSearch("");
    setTaxPickerOpen(true);
  };
  const handleBaseVelocityChange = (name, newValue) => {
    console.log(newValue, name);
    setRiskDetails((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };
  const handleSignPostChange = (name, newValue) => {
    console.log(newValue);
    setSignPost((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };
  // ID170 — load the admin-configured Response Status options once for the scenario dropdowns.
  useEffect(() => {
    executeRef
      .current("GET", `${protectedResources.apiTodoList.endpoint}/response-status/config`)
      .then((res) => {
        const opts = res?.data?.options;
        if (Array.isArray(opts) && opts.length) {
          setResponseStatusOptions(opts.map((o) => ({ label: o.label, value: o.id })));
        }
      })
      .catch(() => {});
  }, []);

  const loadScenariosFromRisk = (item) => {
    // ID98 — single overall Time Horizon & Velocity (fall back across the legacy per-scenario fields)
    setOverallVelocity(
      item.baseVelocity || item.optimisticVelocity || item.pessimisticVelocity || ""
    );
    // ID171 — overall Plausibility description.
    setPlausibilityDescription(item.plausibilityDescription || "");
    if (item.scenarios && item.scenarios.length > 0) {
      setScenarios(item.scenarios);
      return;
    }
    const result = [];
    if (item.optimisticVelocity || item.optimisticConsequenceAmt || item.optimisticQualitative) {
      result.push({
        id: "sc_best",
        label: "Best Case",
        velocity: item.optimisticVelocity || "",
        threatOpp: item.optimisticThreatOpp || "loss",
        consequenceAmt: item.optimisticConsequenceAmt || "",
        qualitative: item.optimisticQualitative || "",
        consequenceType: item.optimisticConsequenceType || "",
        responseStatus: item.optimisticResponseStatus || "",
      });
    }
    if (item.pessimisticVelocity || item.pessimisticConsequenceAmt || item.pessimisticQualitative) {
      result.push({
        id: "sc_worst",
        label: "Worst Case",
        velocity: item.pessimisticVelocity || "",
        threatOpp: item.pessimisticThreatOpp || "loss",
        consequenceAmt: item.pessimisticConsequenceAmt || "",
        qualitative: item.pessimisticQualitative || "",
        consequenceType: item.pessimisticConsequenceType || "",
        responseStatus: item.pessimisticResponseStatus || "",
      });
    }
    if (item.baseVelocity || item.baseConsequenceAmt || item.baseQualitative) {
      result.push({
        id: "sc_base",
        label: "Base Case",
        velocity: item.baseVelocity || "",
        threatOpp: item.baseThreatOpp || "loss",
        consequenceAmt: item.baseConsequenceAmt || "",
        qualitative: item.baseQualitative || "",
        consequenceType: item.baseConsequenceType || "",
        responseStatus: item.baseResponseStatus || "",
      });
    }
    setScenarios(result.length > 0 ? result : [...defaultScenarios]);
  };

  const handleScenarioFieldChange = (idx, field, value) => {
    setScenarios((prev) => {
      const updated = [...prev];
      updated[idx] = { ...updated[idx], [field]: value };
      return updated;
    });
  };

  // A simple horizontal bar showing where the chosen Likelihood sits on the scale (its own visual bar,
  // separate from consequence).
  const renderLikelihoodBar = () => {
    const rows =
      (isLikelihoodMode ? evalCriteria.likelihoodRows : evalCriteria.plausibilityRows) || [];
    const val = isLikelihoodMode ? likelihood : overallVelocity;
    if (!rows.length || !val) return null;
    const idx = rows.findIndex((r) => (r.rating || r.label) === val);
    if (idx < 0) return null;
    const pct = rows.length > 1 ? Math.round(((idx + 1) / rows.length) * 100) : 100;
    return (
      <MDBox sx={{ mt: 1, maxWidth: 300 }}>
        <MDBox sx={{ height: 8, borderRadius: "4px", bgcolor: "#eeeaf3", overflow: "hidden" }}>
          <MDBox sx={{ height: "100%", width: `${pct}%`, bgcolor: "#52009b" }} />
        </MDBox>
        <MDTypography variant="caption" color="text.secondary">
          {val} · level {idx + 1} of {rows.length}
        </MDTypography>
      </MDBox>
    );
  };

  // ID171 — optional free-text "Description" shown under a per-scenario field. The field is stored
  // on the scenario object (Mixed array) so it round-trips on save/load without a schema change.
  const renderScenarioDesc = (scIdx, field, value) => (
    <TextField
      label="Description (optional)"
      value={value || ""}
      fullWidth
      size="small"
      multiline
      minRows={1}
      onChange={(e) => handleScenarioFieldChange(scIdx, field, e.target.value)}
      sx={{ mt: 0.75, mb: 0.5 }}
    />
  );

  // ID70 — a scenario can have MULTIPLE consequences (type + level). Derive the list (legacy
  // single-consequence fallback), and keep consequenceType/qualitative mirrored to the first row
  // for back-compat + the legacy save fields.
  const scenarioConsequences = (sc) => {
    if (Array.isArray(sc.consequences) && sc.consequences.length) return sc.consequences;
    if (sc.consequenceType || sc.qualitative)
      return [{ type: sc.consequenceType || "", level: sc.qualitative || "" }];
    return [];
  };
  const writeConsequences = (scIdx, list) =>
    setScenarios((prev) => {
      const next = [...prev];
      next[scIdx] = {
        ...next[scIdx],
        consequences: list,
        consequenceType: list[0]?.type || "",
        qualitative: list[0]?.level || "",
      };
      return next;
    });
  const addConsequence = (scIdx, type, level) => {
    const list = scenarioConsequences(scenarios[scIdx] || {}).slice();
    if (!list.some((c) => c.type === type && c.level === level)) list.push({ type, level });
    writeConsequences(scIdx, list);
  };
  const removeConsequence = (scIdx, cIdx) => {
    const list = scenarioConsequences(scenarios[scIdx] || {}).slice();
    list.splice(cIdx, 1);
    writeConsequences(scIdx, list);
  };
  // The mini consequence table for one scenario: existing rows as removable chips + an add button.
  const renderConsequences = (sc, scIdx) => {
    const list = scenarioConsequences(sc);
    return (
      <Box>
        {list.length > 0 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 0.75 }}>
            {list.map((c, ci) => (
              // eslint-disable-next-line react/no-array-index-key
              <Chip
                key={ci}
                size="small"
                label={`${c.type || "—"} · ${c.level || "—"}`}
                onDelete={() => removeConsequence(scIdx, ci)}
                sx={{
                  alignSelf: "flex-start",
                  maxWidth: "100%",
                  bgcolor: "#ede7f6",
                  color: "#37474f",
                  fontWeight: 600,
                }}
              />
            ))}
          </Box>
        )}
        <MDButton
          variant="outlined"
          size="small"
          onClick={() => setConsPicker({ open: true, scIdx })}
          sx={{
            justifyContent: "flex-start",
            textTransform: "none",
            borderColor: "rgba(0,0,0,0.23)",
            color: "#52009b",
            width: "100%",
          }}
        >
          {list.length ? "+ Add consequence" : "Select from consequence table…"}
        </MDButton>
      </Box>
    );
  };

  const addScenario = () => {
    setScenarios((prev) => [
      ...prev,
      {
        id: `sc_${Date.now()}`,
        label: "New Scenario",
        velocity: "",
        threatOpp: "loss",
        consequenceAmt: "",
        qualitative: "",
        responseStatus: "",
      },
    ]);
  };

  const removeScenario = (idx) => {
    setScenarios((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleBack = () => {
    if (activeStep === 1 && fromAddSignpost) {
      setCreateRisk(false);
      setShowSignPost(true);
      setValue(1);
      setFromAddSignpost(false);
      setActiveStep(0);
      return;
    }
    if (activeStep === 0) {
      setCreateRisk(false);
      setScenarios([...defaultScenarios]);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const saveSignPost = async () => {
    const riskId =
      RiskDetails.id || (RiskDetails._id && String(RiskDetails._id)) || RiskDetails.riskCategoryId;
    if (!riskId) return;

    if (!spName.trim()) {
      alert("Please give this signpost a name before saving.");
      return;
    }

    // Build legacy parameters blob for backward compat
    let parameters = {};
    if (SignPost.typeValue === "1") {
      parameters = { stock: SignPost.stockCode, from_dt: SignPost.fromDate };
    } else if (SignPost.typeValue === "2") {
      parameters = { fx: SignPost.fx, from_dt: SignPost.fromDt };
    } else if (SignPost.typeValue === "3") {
      parameters = { file: selectedFile?.name, date_row: 1, value_row: 1 };
    } else if (SignPost.typeValue === "4") {
      parameters = {
        url: SignPost.url,
        date_col: SignPost.date_col,
        value_col: SignPost.value_col,
        filter_col: SignPost.filter_col,
        filter_value: SignPost.filter_value,
      };
    } else if (SignPost.typeValue === "5") {
      parameters = { ticker: SignPost.ticker, tickerFreq: SignPost.tickerFreq };
    }

    const data = {
      name: spName || SignPost.desc || "",
      subType: signpostSubType,
      desc: spDesc || SignPost.desc || "",
      type: SignPost.typeValue || "",
      parameters,
      signpostLibraryId: selectedLibraryEntry?.id || selectedLibraryEntry?._id || null,
      thresholds: spThresholds,
      triggers: spTriggers,
      noofiterations: SignPost.iterations || "100",
      timeframe: SignPost.timeframe || timeFrame || "medium-term",
      optValue: SignPost.optValue || "",
      pessValue: SignPost.pessValue || "",
    };

    try {
      await execute(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/${riskId}/signposts`,
        data
      );
      setSelectedSignPost("");
      setSignPost({});
      setSpName("");
      setSpDesc("");
      setSpThresholds([]);
      setSpTriggers([]);
      setSelectedLibraryEntry(null);
      setSignpostSubType("quantitative");
      setSignpostDialogOpen(false); // ID89 — close the "+ Add Signpost" pop-up
      setCreateRisk(false);
      setShowSignPost(true); // return to the right panel
      setReload((r) => !r);
    } catch (err) {
      // eslint-disable-next-line no-alert
      alert(`Failed to save signpost: ${err?.message || err}`);
    }
  };

  // ─── ID88 attachments ───────────────────────────────────────────────
  const readFileAsDataUrl = (file) =>
    new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });

  const handleAttachmentUpload = async (fileList) => {
    const riskId = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    if (!riskId) {
      alert("Save the risk first, then add attachments.");
      return;
    }
    const files = Array.from(fileList || []);
    if (files.length === 0) return;
    setAttachUploading(true);
    const run = executeRef.current;
    const uploadOne = async (file) => {
      const dataBase64 = await readFileAsDataUrl(file);
      const res = await run(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/${riskId}/attachments`,
        { name: file.name, contentType: file.type, dataBase64 }
      );
      if (res?.success) setAttachments(Array.isArray(res.data) ? res.data : []);
      else alert(res?.message || `Failed to upload ${file.name}.`);
    };
    // sequential so each $push returns the latest array without races
    await files.reduce((p, f) => p.then(() => uploadOne(f)), Promise.resolve());
    setAttachUploading(false);
  };

  const handleAttachmentDelete = async (idx) => {
    const riskId = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    if (!riskId) return;
    // eslint-disable-next-line no-restricted-globals, no-alert
    if (!window.confirm("Remove this attachment?")) return;
    const run = executeRef.current;
    const res = await run(
      "DELETE",
      `${protectedResources.apiTodoList.endpoint}/emergingRisk/${riskId}/attachments/${idx}`
    );
    if (res?.success) setAttachments(Array.isArray(res.data) ? res.data : []);
    else alert(res?.message || "Failed to remove attachment.");
  };

  const openAddSignpostDialog = () => {
    setSpName("");
    setSpDesc("");
    setSpThresholds([]);
    setSpTriggers([]);
    setSelectedLibraryEntry(null);
    setSignpostSubType("quantitative");
    setSignpostDialogOpen(true);
  };

  // Create the risk once and return its id (or the existing id if it was already created).
  // Does not navigate — callers decide what to do next.
  const ensureRiskSaved = async () => {
    const existingId = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    if (existingId) return existingId;
    if (!validateRiskDetailsFields()) return null;
    const sc0 = scenarios[0] || {};
    const sc1 = scenarios[1] || {};
    const requestBody = {
      Title: RiskDetails.Title,
      Description: RiskDetails.Description,
      Category: selectedCategory,
      SubCategory: selectedSubCategory,
      timeFrame,
      likelihood, // ID172
      linkedHorizonTheme,
      // ID171 — overall Plausibility description (risk-level, not per-scenario)
      plausibilityDescription,
      // ID98 — single overall Plausibility applied to every scenario field
      scenarios: scenarios.map((sc) => ({ ...sc, velocity: overallVelocity })),
      baseVelocity: overallVelocity,
      optimisticVelocity: overallVelocity,
      optimisticThreatOpp: sc0.threatOpp || "loss",
      optimisticConsequenceAmt: sc0.consequenceAmt || "",
      optimisticQualitative: sc0.qualitative || "",
      optimisticConsequenceType: sc0.consequenceType || "",
      optimisticResponseStatus: sc0.responseStatus || "",
      pessimisticVelocity: overallVelocity,
      pessimisticThreatOpp: sc1.threatOpp || "loss",
      pessimisticConsequenceAmt: sc1.consequenceAmt || "",
      pessimisticQualitative: sc1.qualitative || "",
      pessimisticConsequenceType: sc1.consequenceType || "",
      pessimisticResponseStatus: sc1.responseStatus || "",
    };
    try {
      const response = await execute(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/emergingRisk/create`,
        requestBody
      );
      if (!response?.success) {
        alert(response?.message || "Failed to create risk.");
        return null;
      }
      const saved = response.data || {};
      const newId = saved.id || saved._id;
      setSelectedSignPost("");
      setSignPost({});
      setRiskDetails({ ...saved, id: newId });
      setSelectedCategory(saved.Category || selectedCategory || "");
      setSelectedSubCategory(saved.SubCategory || selectedSubCategory || "");
      setJustCreated(true);
      return newId;
    } catch (err) {
      // eslint-disable-next-line no-alert
      alert("Failed to create risk.");
      return null;
    }
  };

  // Main "Save" — persist the risk, then open the merged details view (scenarios → attachments → signposts).
  // If the risk was already created (e.g. via "+ Add Signpost"), Save must UPDATE it so any
  // scenarios/details added afterwards are persisted — otherwise they were silently dropped.
  const postRiskData = async () => {
    const existingId = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    let id = existingId;
    if (existingId) {
      const ok = await handleModifyRiskDetails(existingId);
      if (!ok) return;
    } else {
      id = await ensureRiskSaved();
      if (!id) return;
    }
    setCreateRisk(false);
    setShowSignPost(true);
    setEditMode(false);
    setActiveStep(0);
    setReload((r) => !r);
  };
  // Keep the ref pointing at the latest postRiskData so the advance auto-save uses current state.
  postRiskDataRef.current = postRiskData;

  // ID89 — "+ Add Signpost" on the create page: save the risk first, then open the add-signpost pop-up.
  // Kept for reference — the "+ Add Signpost" button is commented out (Suggest signposts only).
  // eslint-disable-next-line no-unused-vars
  const handleAddSignpostFromCreate = async () => {
    const id = await ensureRiskSaved();
    if (!id) return;
    openAddSignpostDialog();
  };
  // Phase 3 — "Suggest signposts" on the create page: save the risk first (the agent needs its id),
  // then open the AI proposal review. Pass the returned id since RiskDetails state updates async.
  const handleSuggestSignpostsFromCreate = async () => {
    const id = await ensureRiskSaved();
    if (!id) return;
    openSuggestSignposts(id);
  };
  // ─── ID90 read-only display helpers ─────────────────────────────────
  const roField = (label, val) => {
    if (val === undefined || val === null || String(val).trim() === "") return null;
    return (
      <Box sx={{ mr: 4, mb: 1.5, minWidth: 180 }}>
        <MDTypography
          variant="caption"
          sx={{
            display: "block",
            color: "#9e9e9e",
            textTransform: "uppercase",
            fontSize: 11,
            letterSpacing: 0.4,
          }}
        >
          {label}
        </MDTypography>
        <MDTypography
          variant="body2"
          sx={{ color: "#1c1c1c", whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {val}
        </MDTypography>
      </Box>
    );
  };

  const renderReadOnlyDetails = () => (
    <Box>
      <MDBox display="flex" flexWrap="wrap" sx={{ mb: 1 }}>
        {roField("Description", RiskDetails.Description)}
      </MDBox>
      {/* ID196 — Category, Sub Category and the Likelihood/Plausibility assessment shown here at the
          bottom (as they were before). The top Scenario-assessment panel no longer repeats them. */}
      <MDBox display="flex" flexWrap="wrap">
        {roField("Category", selectedCategory || RiskDetails.Category)}
        {roField("Sub Category", selectedSubCategory || RiskDetails.SubCategory)}
        {roField(
          isLikelihoodMode ? "Likelihood" : "Plausibility",
          isLikelihoodMode
            ? likelihood || RiskDetails.likelihood
            : overallVelocity || RiskDetails.baseVelocity
        )}
      </MDBox>
    </Box>
  );

  // ─── ID88 attachments section ───────────────────────────────────────
  const formatBytes = (n) => {
    if (!n) return "";
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  };

  const renderAttachmentsSection = () => {
    const riskId = RiskDetails.id || (RiskDetails._id && String(RiskDetails._id));
    return (
      <MDBox sx={{ px: 1, mt: 1 }}>
        <Divider sx={{ my: 2 }} />
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDTypography variant="h5" sx={{ color: "#52009b", fontWeight: 700 }}>
            Attachments
          </MDTypography>
          {riskId && (
            <Button
              component="label"
              variant="outlined"
              disabled={attachUploading}
              sx={{ color: "#52009b", borderColor: "#52009b", textTransform: "none" }}
            >
              {attachUploading ? "Uploading…" : "+ Add Files"}
              <input
                type="file"
                hidden
                multiple
                onChange={(e) => {
                  handleAttachmentUpload(e.target.files);
                  e.target.value = "";
                }}
              />
            </Button>
          )}
        </MDBox>
        {!riskId ? (
          <MDTypography variant="caption" color="text.secondary">
            Save the risk first to add attachments.
          </MDTypography>
        ) : attachments.length === 0 ? (
          <MDTypography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            No attachments yet.
          </MDTypography>
        ) : (
          <MDBox sx={{ mt: 1 }}>
            {attachments.map((a, i) => (
              <MDBox
                key={`${a.blobName || a.name}-${i}`}
                display="flex"
                alignItems="center"
                gap={1}
                sx={{
                  py: 0.75,
                  px: 1,
                  borderBottom: "1px solid rgba(0,0,0,0.06)",
                }}
              >
                <ArticleIcon fontSize="small" sx={{ color: "#52009b" }} />
                <Link
                  href={a.url}
                  target="_blank"
                  rel="noopener"
                  sx={{ flex: 1, color: "#1c1c1c", textDecoration: "none", wordBreak: "break-all" }}
                >
                  {a.name}
                </Link>
                <MDTypography variant="caption" color="text.secondary">
                  {formatBytes(a.size)}
                </MDTypography>
                <IconButton size="small" color="error" onClick={() => handleAttachmentDelete(i)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </MDBox>
            ))}
          </MDBox>
        )}
      </MDBox>
    );
  };

  // Advance overlay phase (1 assess → 2 save → 3 scan) + its message.
  const advanceSteps = ["Assessing scenarios", "Saving risk", "Horizon scan"];
  let advanceStep = 3;
  let advanceTitle = "Generating horizon themes for this risk…";
  let advanceSub =
    "Scanning Global, geography, sector and organisation news (~20s). You'll be able to review the emerging themes and add or remove any once they appear.";
  if (aiPopulating) {
    advanceStep = 1;
    advanceTitle = "Assessing best & worst case with AI…";
    advanceSub =
      "Reading the theme and your company context to draft the best/worst scenarios and likelihood.";
  } else if (advanceSaving) {
    advanceStep = 2;
    advanceTitle = "Saving to your watchlist…";
    advanceSub = "Creating the risk record on your watchlist.";
  }

  // dialog box
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Full-screen overlay across the whole advance sequence (AI assess → save → horizon scan),
          centre-screen with a blurred backdrop, so the user just watches it happen then reviews &
          publishes. Dismissible, and auto-hides when the themes arrive / the scan finishes. */}
      {advancing && !genDismissed && (
        <MDBox
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: 1400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            bgcolor: "rgba(26,21,38,0.35)",
            backdropFilter: "blur(4px)",
          }}
          onClick={() => setGenDismissed(true)}
        >
          <MDBox
            onClick={(e) => e.stopPropagation()}
            sx={{
              bgcolor: "#fff",
              borderRadius: "16px",
              boxShadow: "0 20px 60px rgba(26,21,38,0.35)",
              p: 3.5,
              maxWidth: 480,
              width: "100%",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.25,
            }}
          >
            {/* 3-step progress: done ✓ · active (filled) · pending */}
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mb: 0.5,
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {advanceSteps.map((label, i) => {
                const n = i + 1;
                const done = n < advanceStep;
                const active = n === advanceStep;
                let dotBg = "#eceaf2";
                if (done) dotBg = "#2e7d32";
                else if (active) dotBg = "#52009b";
                let lblColor = "#9e9e9e";
                if (active) lblColor = "#52009b";
                else if (done) lblColor = "#2e7d32";
                return (
                  <MDBox key={label} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <MDBox
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        display: "grid",
                        placeItems: "center",
                        fontSize: 12,
                        fontWeight: 700,
                        color: done || active ? "#fff" : "#9e9e9e",
                        bgcolor: dotBg,
                      }}
                    >
                      {done ? "✓" : n}
                    </MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{ color: lblColor, fontWeight: active ? 700 : 600 }}
                    >
                      {label}
                    </MDTypography>
                    {n < advanceSteps.length && (
                      <MDBox
                        sx={{
                          width: 18,
                          height: 2,
                          bgcolor: done ? "#2e7d32" : "#eceaf2",
                          mx: 0.25,
                        }}
                      />
                    )}
                  </MDBox>
                );
              })}
            </MDBox>
            <CircularProgress size={44} sx={{ color: "#52009b" }} />
            <MDTypography variant="h6" sx={{ color: "#52009b", fontWeight: 700, mt: 0.5 }}>
              {advanceTitle}
            </MDTypography>
            <MDTypography variant="body2" color="text.secondary">
              {advanceSub}
            </MDTypography>
            <MDButton
              variant="text"
              onClick={() => setGenDismissed(true)}
              sx={{ color: "#52009b", textTransform: "none", mt: 0.5 }}
            >
              Continue in background
            </MDButton>
          </MDBox>
        </MDBox>
      )}
      <form>
        {createRisk ? (
          <Grid
            style={{
              backgroundColor: "white",
              borderRadius: "5px",
              padding: "12px",
            }}
          >
            {" "}
            <Grid
              item
              md={12}
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 5,
                backgroundColor: "white",
                borderBottom: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <MDBox px={2} py={1}>
                <MDBox
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <MDTypography variant="h5" gutterBottom>
                    Create Risks
                  </MDTypography>
                  <MDBox sx={{ display: "flex", gap: 1.5, flexShrink: 0 }}>
                    <MDButton
                      color="black"
                      variant="outlined"
                      onClick={handleBack}
                      sx={{ color: "#464d60", borderColor: "#3d4458" }}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      onClick={postRiskData}
                      variant="contained"
                      sx={{
                        backgroundColor: "#52009b",
                        color: "#f7f4fb",
                        "&:hover": { backgroundColor: "#3a0070" },
                      }}
                    >
                      Save
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Grid>
            <Grid
              style={{
                backgroundColor: "white",
                borderRadius: "5px",
                padding: "12px",
              }}
            >
              {activeStep === 0 ? (
                <Grid container spacing={2} sx={{ pl: "8px", pb: "12px" }}>
                  <Grid item md={12} sx={12} sm={12} xs={12} lg={12}>
                    <TextField
                      label="Title"
                      variant="outlined"
                      name="Title"
                      sx={{ width: "30%", marginRight: "10px" }}
                      value={RiskDetails.Title || ""}
                      onChange={handleRiskDetailsChange}
                      required
                      error={!!formErrors.Title}
                      helperText={formErrors.Title}
                    />
                    <TextField
                      label="Description"
                      variant="outlined"
                      name="Description"
                      sx={{ width: "60%" }}
                      value={RiskDetails.Description || ""}
                      onChange={handleRiskDetailsChange}
                      required
                      error={!!formErrors.Description}
                      helperText={formErrors.Description}
                    />
                  </Grid>
                  <Grid item md={12} sx={12} sm={12} xs={12} lg={12}>
                    {allSubCats ? (
                      // ID78 — taxonomy category is chosen from a full-taxonomy pop-up.
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{ fontWeight: 600, color: "#374151", display: "block", mb: 0.5 }}
                        >
                          Taxonomy category <span style={{ color: "#d32f2f" }}>*</span>
                        </MDTypography>
                        <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                          <MDButton
                            variant="outlined"
                            color="info"
                            size="small"
                            startIcon={<AccountTreeIcon />}
                            onClick={openTaxonomyPicker}
                          >
                            {selectedCategory ? "Change category" : "Select category"}
                          </MDButton>
                          {selectedCategory ? (
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                px: "10px",
                                py: "5px",
                                borderRadius: "6px",
                                fontSize: "0.8rem",
                                fontWeight: 700,
                                bgcolor: "#ede7f6",
                                color: "#52009b",
                                border: "1px solid #ce93d8",
                              }}
                            >
                              {selectedCategory}
                              {selectedSubCategory ? (
                                <>
                                  <span style={{ opacity: 0.55 }}>›</span>
                                  {selectedSubCategory}
                                </>
                              ) : null}
                            </Box>
                          ) : (
                            <MDTypography variant="caption" sx={{ color: "#9e9e9e" }}>
                              No taxonomy category selected
                            </MDTypography>
                          )}
                        </MDBox>
                        {(formErrors.Category || formErrors.SubCategory) && (
                          <MDTypography
                            variant="caption"
                            sx={{ color: "#d32f2f", display: "block", mt: 0.5 }}
                          >
                            {formErrors.Category || formErrors.SubCategory}
                          </MDTypography>
                        )}
                      </MDBox>
                    ) : (
                      ""
                    )}
                    {/* ID196 — Likelihood (mandatory), brought back up next to the taxonomy category. */}
                    <MDBox sx={{ mt: 2 }}>
                      <MDTypography
                        variant="caption"
                        sx={{ fontWeight: 600, color: "#374151", display: "block", mb: 0.5 }}
                      >
                        {isLikelihoodMode ? "Likelihood" : "Plausibility"}{" "}
                        <span style={{ color: "#d32f2f" }}>*</span>
                      </MDTypography>
                      <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                        <MDButton
                          variant="outlined"
                          color="info"
                          size="small"
                          onClick={() => setPlausPickerOpen(true)}
                        >
                          {(isLikelihoodMode ? likelihood : overallVelocity)
                            ? `Change ${isLikelihoodMode ? "likelihood" : "plausibility"}`
                            : `Select ${isLikelihoodMode ? "likelihood" : "plausibility"}`}
                        </MDButton>
                        {(isLikelihoodMode ? likelihood : overallVelocity) ? (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              px: "10px",
                              py: "5px",
                              borderRadius: "6px",
                              fontSize: "0.8rem",
                              fontWeight: 700,
                              bgcolor: "#ede7f6",
                              color: "#52009b",
                              border: "1px solid #ce93d8",
                            }}
                          >
                            {isLikelihoodMode ? likelihood : overallVelocity}
                          </Box>
                        ) : (
                          <MDTypography variant="caption" sx={{ color: "#9e9e9e" }}>
                            No {isLikelihoodMode ? "likelihood" : "plausibility"} selected
                          </MDTypography>
                        )}
                      </MDBox>
                      {formErrors.likelihood && (
                        <MDTypography
                          variant="caption"
                          sx={{ color: "#d32f2f", display: "block", mt: 0.5 }}
                        >
                          {formErrors.likelihood}
                        </MDTypography>
                      )}
                    </MDBox>
                    {/* ID78 — full-taxonomy picker pop-up: click a sub-category to select the pair. */}
                    <Dialog
                      open={taxPickerOpen}
                      onClose={() => setTaxPickerOpen(false)}
                      maxWidth="sm"
                      fullWidth
                    >
                      <DialogTitle sx={{ pb: 1 }}>Select taxonomy category</DialogTitle>
                      <DialogContent dividers>
                        <TextField
                          fullWidth
                          size="small"
                          autoFocus
                          placeholder="Search categories or sub-categories…"
                          value={taxSearch}
                          onChange={(e) => setTaxSearch(e.target.value)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                          sx={{ mb: 1.5 }}
                        />
                        {(() => {
                          const q = taxSearch.trim().toLowerCase();
                          const rows = (allSubCats || [])
                            .map((item) => {
                              const cat = item.Category || "";
                              const subs = Array.isArray(item.SubCategory) ? item.SubCategory : [];
                              const catHit = cat.toLowerCase().includes(q);
                              const shownSubs = q
                                ? catHit
                                  ? subs
                                  : subs.filter((s) => String(s).toLowerCase().includes(q))
                                : subs;
                              return { cat, catHit, shownSubs, subs };
                            })
                            .filter((r) => (q ? r.catHit || r.shownSubs.length : true));
                          if (!rows.length) {
                            return (
                              <MDTypography variant="caption" sx={{ color: "#9e9e9e" }}>
                                No matching taxonomy categories.
                              </MDTypography>
                            );
                          }
                          return rows.map((r) => (
                            <Accordion
                              key={r.cat}
                              disableGutters
                              expanded={q ? true : taxExpanded === r.cat}
                              onChange={() =>
                                !q && setTaxExpanded(taxExpanded === r.cat ? null : r.cat)
                              }
                              sx={{
                                boxShadow: "none",
                                border: "1px solid #eee",
                                "&:before": { display: "none" },
                                mb: 0.5,
                              }}
                            >
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <MDTypography
                                  variant="button"
                                  sx={{
                                    fontWeight: 700,
                                    color: selectedCategory === r.cat ? "#52009b" : "#37474f",
                                  }}
                                >
                                  {r.cat}
                                </MDTypography>
                              </AccordionSummary>
                              <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                                {r.shownSubs.length ? (
                                  r.shownSubs.map((s) => {
                                    const isSel =
                                      selectedCategory === r.cat && selectedSubCategory === s;
                                    return (
                                      <Box
                                        key={s}
                                        onClick={() => handleTaxonomyPick(r.cat, s)}
                                        sx={{
                                          px: 1.25,
                                          py: 0.75,
                                          borderRadius: "6px",
                                          cursor: "pointer",
                                          fontSize: "0.85rem",
                                          fontWeight: isSel ? 700 : 500,
                                          color: isSel ? "#52009b" : "#455a64",
                                          bgcolor: isSel ? "#ede7f6" : "transparent",
                                          "&:hover": { bgcolor: "#f3edfb" },
                                        }}
                                      >
                                        {isSel ? "✓ " : ""}
                                        {s}
                                      </Box>
                                    );
                                  })
                                ) : (
                                  <MDTypography variant="caption" sx={{ color: "#9e9e9e" }}>
                                    No sub-categories.
                                  </MDTypography>
                                )}
                              </AccordionDetails>
                            </Accordion>
                          ));
                        })()}
                      </DialogContent>
                      <DialogActions>
                        <MDButton
                          variant="text"
                          color="dark"
                          onClick={() => setTaxPickerOpen(false)}
                        >
                          Cancel
                        </MDButton>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                  {/* Likelihood picker + "Populate with AI" button removed (PO 2026-09-18): the
                      assessment (scenarios + likelihood/velocity) is populated automatically by AI. */}
                  <Grid item md={12} sx={{ py: "4px !important" }}>
                    <Divider sx={{ my: "6px", borderWidth: "1px", width: "100%" }} />
                  </Grid>
                  <Grid container columns={12} spacing={2}>
                    {scenarios.map((sc, scIdx) => (
                      <Grid item md={12} xs={12} key={sc.id}>
                        <Card
                          sx={{
                            padding: 2,
                            position: "relative",
                            mb: 2,
                            borderLeft: `6px solid ${
                              scIdx === 0 ? "#2e7d32" : scIdx === 1 ? "#c62828" : "#52009b"
                            }`,
                            bgcolor: scIdx === 0 ? "#f3faf4" : scIdx === 1 ? "#fdf5f5" : "#faf8fc",
                          }}
                        >
                          {scIdx >= 2 && (
                            <MDButton
                              size="small"
                              variant="text"
                              color="error"
                              sx={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                minWidth: "auto",
                                p: "2px 6px",
                              }}
                              onClick={() => removeScenario(scIdx)}
                            >
                              ✕
                            </MDButton>
                          )}
                          <CardContent sx={{ pb: "8px !important" }}>
                            <TextField
                              label="Scenario Name"
                              value={sc.label}
                              fullWidth
                              size="small"
                              onChange={(e) =>
                                handleScenarioFieldChange(scIdx, "label", e.target.value)
                              }
                              InputProps={scIdx < 2 ? { readOnly: true } : {}}
                              sx={{ mb: 1 }}
                            />
                            {renderScenarioDesc(scIdx, "labelDescription", sc.labelDescription)}
                          </CardContent>
                          {/* Scenario as a table ROW — attributes side by side. */}
                          <Box
                            sx={{
                              display: "flex",
                              gap: 2,
                              flexWrap: "wrap",
                              alignItems: "flex-start",
                              px: 2,
                              pb: 1,
                            }}
                          >
                            <Box sx={{ flex: "1 1 460px", minWidth: 300 }}>
                              {/* ID81 — Consequence direction + quantitative/qualitative in one box */}
                              <Box
                                sx={{
                                  border: "1px solid rgba(82,0,155,0.25)",
                                  borderRadius: 1,
                                  p: 1.5,
                                  mb: 1,
                                }}
                              >
                                <MDTypography
                                  variant="h6"
                                  sx={{ pd: 2, color: "#52009b" }}
                                  gutterBottom
                                >
                                  Consequence
                                </MDTypography>
                                <FormControl>
                                  <RadioGroup
                                    row
                                    defaultValue="loss"
                                    value={sc.threatOpp || "loss"}
                                    onChange={(_, newValue) =>
                                      handleScenarioFieldChange(
                                        scIdx,
                                        "threatOpp",
                                        newValue ?? "loss"
                                      )
                                    }
                                    sx={{ pd: 2 }}
                                  >
                                    <FormControlLabel
                                      value="loss"
                                      control={<Radio />}
                                      label="Threat/Loss"
                                    />
                                    <FormControlLabel
                                      value="gain"
                                      control={<Radio />}
                                      label="Opportunity/Gain"
                                    />
                                  </RadioGroup>
                                </FormControl>
                                {/* Qualitative by default; toggle to quantitative. Only the chosen shows. */}
                                <Box sx={{ display: "flex", gap: 1, mt: 1, mb: 1.5 }}>
                                  {[
                                    { v: "qualitative", l: "Qualitative" },
                                    { v: "quantitative", l: "Quantitative" },
                                  ].map((opt) => (
                                    <MDButton
                                      key={opt.v}
                                      size="small"
                                      variant={
                                        (sc.consequenceMode || "qualitative") === opt.v
                                          ? "contained"
                                          : "outlined"
                                      }
                                      color={
                                        (sc.consequenceMode || "qualitative") === opt.v
                                          ? "info"
                                          : "secondary"
                                      }
                                      onClick={() =>
                                        handleScenarioFieldChange(scIdx, "consequenceMode", opt.v)
                                      }
                                      sx={{ textTransform: "none", minWidth: 0, px: 1.5, py: 0.25 }}
                                    >
                                      {opt.l}
                                    </MDButton>
                                  ))}
                                </Box>
                                {(sc.consequenceMode || "qualitative") === "quantitative" ? (
                                  <>
                                    <TextField
                                      label="Enter Amount($)"
                                      variant="outlined"
                                      // ID83 — threat/loss shows a red "−" prefix; opportunity/gain a black "+".
                                      sx={{
                                        width: "60%",
                                        "& input": {
                                          color: sc.threatOpp === "gain" ? "#000" : "#d32f2f",
                                        },
                                      }}
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <span
                                              style={{
                                                color: sc.threatOpp === "gain" ? "#000" : "#d32f2f",
                                                fontWeight: 700,
                                              }}
                                            >
                                              {sc.threatOpp === "gain" ? "+" : "−"}
                                            </span>
                                          </InputAdornment>
                                        ),
                                      }}
                                      value={sc.consequenceAmt || ""}
                                      onChange={(e) =>
                                        handleScenarioFieldChange(
                                          scIdx,
                                          "consequenceAmt",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {renderScenarioDesc(
                                      scIdx,
                                      "consequenceAmtDescription",
                                      sc.consequenceAmtDescription
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {renderConsequences(sc, scIdx)}
                                    {renderScenarioDesc(
                                      scIdx,
                                      "qualitativeDescription",
                                      sc.qualitativeDescription
                                    )}
                                  </>
                                )}
                              </Box>
                            </Box>
                            <Box sx={{ flex: "1 1 240px", minWidth: 200 }}>
                              <MDTypography
                                variant="h6"
                                gutterBottom
                                sx={{ pd: 2, color: "#52009b" }}
                              >
                                Response Status
                              </MDTypography>
                              <Autocomplete
                                sx={{ pd: 2 }}
                                value={sc.responseStatus || ""}
                                onChange={(_, newValue) =>
                                  handleScenarioFieldChange(
                                    scIdx,
                                    "responseStatus",
                                    newValue?.label ?? ""
                                  )
                                }
                                options={responseStatusOptions}
                                renderInput={(params) => (
                                  <TextField {...params} variant="outlined" />
                                )}
                              />
                              {renderScenarioDesc(
                                scIdx,
                                "responseStatusDescription",
                                sc.responseStatusDescription
                              )}
                            </Box>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                    <Grid item xs={12}>
                      <MDButton
                        variant="outlined"
                        sx={{ color: "#52009b", borderColor: "#52009b", mt: 1 }}
                        onClick={addScenario}
                      >
                        + Add Scenario
                      </MDButton>
                    </Grid>
                    {/* ID89 — saves the risk first, then opens the add-signpost pop-up */}
                    <Grid item xs={12}>
                      <MDButton
                        variant="outlined"
                        sx={{
                          color: "#52009b",
                          borderColor: "#52009b",
                          "&:hover": { borderColor: "#3a0070" },
                          mr: 1,
                        }}
                        onClick={handleSuggestSignpostsFromCreate}
                      >
                        ✨ Suggest signposts
                      </MDButton>
                      {/* "+ Add Signpost" (manual add) removed — signposts now come from
                          ✨ Suggest signposts (quantitative only).
                      <MDButton
                        variant="contained"
                        sx={{
                          bgcolor: "#52009b",
                          color: "#fff",
                          "&:hover": { bgcolor: "#3a0070" },
                        }}
                        onClick={handleAddSignpostFromCreate}
                      >
                        + Add Signpost
                      </MDButton>
                      */}
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mt: 0.5 }}
                      >
                        Saves the risk first, then lets you suggest signposts. A risk needs at least
                        one signpost to be monitored.
                      </MDTypography>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              {activeStep === 1 ? (
                <>
                  {/* Set expectations: the per-risk Horizon Scan is automatic, so the user knows the
                      "themes for this risk" will appear after saving — not that they must add a
                      signpost here. Addresses "I don't know when the horizon scan theme comes." */}
                  <MDBox
                    sx={{
                      display: "flex",
                      gap: 1.25,
                      p: 1.5,
                      mb: 2,
                      borderRadius: 1,
                      bgcolor: "rgba(82,0,155,0.05)",
                      border: "1px solid rgba(82,0,155,0.15)",
                    }}
                  >
                    <Icon sx={{ color: "#52009b", mt: "2px" }}>radar</Icon>
                    <MDBox>
                      <MDTypography variant="button" fontWeight="bold" sx={{ color: "#52009b" }}>
                        A Horizon Scan is set up for this risk automatically
                      </MDTypography>
                      <MDTypography variant="caption" color="text.secondary" display="block">
                        When you save, it scans Global, geography, sector and organisation news and
                        lists the emerging <b>Themes for this risk</b> in the saved record — the
                        first results appear within a few minutes and refresh daily. You don&apos;t
                        need to add anything here. Adding a signpost below is optional — use it only
                        to track a specific number (e.g. a price, rate or index).
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <AddSignpostForm
                    spName={spName}
                    setSpName={setSpName}
                    spDesc={spDesc}
                    setSpDesc={setSpDesc}
                    signpostSubType={signpostSubType}
                    setSignpostSubType={setSignpostSubType}
                    signpostLibraryList={signpostLibraryList}
                    selectedLibraryEntry={selectedLibraryEntry}
                    setSelectedLibraryEntry={setSelectedLibraryEntry}
                    handleSelectSignPost={handleSelectSignPost}
                    spThresholds={spThresholds}
                    setSpThresholds={setSpThresholds}
                    spTriggers={spTriggers}
                    setSpTriggers={setSpTriggers}
                    scenarioOptionLabels={scenarioOptionLabels}
                    findScenarioByLabel={findScenarioByLabel}
                    scenarioAmount={scenarioAmount}
                    scenarioToKey={scenarioToKey}
                    riskId={RiskDetails.id || RiskDetails._id}
                    onOpenFinder={() => setFinderOpen(true)}
                    onOpenSuggest={handleSuggestSignpostsFromCreate}
                    prioritisationMatrix={evalCriteria.prioritisationMatrix}
                  />
                </>
              ) : (
                ""
              )}
              {SHOW_LEGACY_SIGNPOST_FORM ? (
                <Grid container spacing={3} sx={{ pl: "8px", pb: "90px" }}>
                  {/* ── AI signpost finder (ID96) entry + bypass hint ── */}
                  <Grid item xs={12}>
                    <MDBox
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                        p: 1.5,
                        borderRadius: 1,
                        bgcolor: "rgba(82,0,155,0.05)",
                        border: "1px solid rgba(82,0,155,0.15)",
                      }}
                    >
                      <MDButton
                        variant="contained"
                        sx={{
                          bgcolor: "#52009b",
                          color: "#fff",
                          "&:hover": { bgcolor: "#3a0070" },
                        }}
                        disabled={!(RiskDetails.id || RiskDetails._id)}
                        onClick={() => setFinderOpen(true)}
                      >
                        ✨ Find the best available signposts
                      </MDButton>
                      <MDTypography variant="caption" color="text.secondary">
                        {RiskDetails.id || RiskDetails._id
                          ? "Let AI suggest signposts from our library (and the web) using your risk & company context — or set one up manually below / choose a Qualitative signal."
                          : "Save the risk details first to enable the AI signpost finder. You can still add a signpost manually below."}
                      </MDTypography>
                    </MDBox>
                  </Grid>
                  {/* ── Name & description ── */}
                  <Grid item xs={12}>
                    <MDTypography variant="h6" sx={{ color: "#52009b" }} gutterBottom>
                      Signpost Details
                    </MDTypography>
                    <MDBox display="flex" gap={2} flexWrap="wrap">
                      <TextField
                        label="Signpost Name *"
                        sx={{ width: "280px" }}
                        value={spName}
                        onChange={(e) => setSpName(e.target.value)}
                        size="small"
                        required
                        error={spName.trim() === ""}
                        helperText={spName.trim() === "" ? "Name is required" : ""}
                      />
                      <TextField
                        label="Description"
                        sx={{ width: "400px" }}
                        value={spDesc}
                        onChange={(e) => setSpDesc(e.target.value)}
                        size="small"
                      />
                    </MDBox>
                  </Grid>

                  {/* ── Sub-type selector ── */}
                  <Grid item xs={12}>
                    <MDTypography variant="h6" sx={{ color: "#52009b" }} gutterBottom>
                      Signpost Type
                    </MDTypography>
                    <RadioGroup
                      row
                      value={signpostSubType}
                      onChange={(e) => setSignpostSubType(e.target.value)}
                    >
                      <FormControlLabel
                        value="quantitative"
                        control={<Radio />}
                        label="Quantitative (data feed + thresholds)"
                      />
                      <FormControlLabel
                        value="qualitative"
                        control={<Radio />}
                        label="Qualitative (LLM trigger monitoring)"
                      />
                    </RadioGroup>
                  </Grid>

                  {/* ── Library picker ── */}
                  <Grid item xs={12}>
                    <MDTypography variant="h6" sx={{ color: "#52009b" }} gutterBottom>
                      Signpost Library (optional — pre-configured data source)
                    </MDTypography>
                    <Autocomplete
                      sx={{ width: "420px" }}
                      options={signpostLibraryList.filter(
                        (l) => l.isActive !== false && l.dataSourceType !== "llm_search"
                      )}
                      getOptionLabel={(o) => `${o.name} (${o.dataSourceType})`}
                      value={selectedLibraryEntry}
                      onChange={(_, v) => {
                        setSelectedLibraryEntry(v);
                        if (v) {
                          // Auto-fill name from library if the user hasn't typed one yet
                          if (!spName.trim()) setSpName(v.name);
                          const typeMap = {
                            stock_yahoo: "1",
                            fx_alphavantage: "2",
                            excel_online: "4",
                            econdb: "5",
                            url_scrape: "4",
                            custom_api: "4",
                          };
                          handleSelectSignPost(
                            null,
                            v.dataSourceType,
                            typeMap[v.dataSourceType] || ""
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Pick from library"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                    {selectedLibraryEntry && (
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 0.5, display: "block" }}
                      >
                        Source: {selectedLibraryEntry.dataSourceType} · Unit:{" "}
                        {selectedLibraryEntry.unit || "—"} · {selectedLibraryEntry.description}
                      </MDTypography>
                    )}
                  </Grid>

                  {/* ── Quantitative: threshold builder ── */}
                  {signpostSubType === "quantitative" && (
                    <Grid item xs={12}>
                      <MDTypography variant="h6" sx={{ color: "#52009b" }} gutterBottom>
                        Thresholds
                      </MDTypography>
                      {spThresholds.map((t, i) => (
                        <MDBox
                          key={i}
                          display="flex"
                          gap={1}
                          alignItems="center"
                          mb={1}
                          flexWrap="wrap"
                        >
                          <TextField
                            size="small"
                            label="Value"
                            type="number"
                            sx={{ width: 110 }}
                            value={t.value}
                            onChange={(e) => {
                              const updated = [...spThresholds];
                              updated[i] = {
                                ...updated[i],
                                value: parseFloat(e.target.value) || 0,
                              };
                              setSpThresholds(updated);
                            }}
                          />
                          <Autocomplete
                            size="small"
                            sx={{ width: 130 }}
                            value={t.direction}
                            onChange={(_, v) => {
                              const u = [...spThresholds];
                              u[i] = { ...u[i], direction: v || "above" };
                              setSpThresholds(u);
                            }}
                            options={["above", "below"]}
                            renderInput={(p) => <TextField {...p} label="Direction" />}
                            disableClearable
                          />
                          <Autocomplete
                            size="small"
                            sx={{ width: 180 }}
                            value={t.scenarioLabel || ""}
                            onChange={(_, v) => {
                              const u = [...spThresholds];
                              const sc = findScenarioByLabel(v);
                              const amt = scenarioAmount(sc);
                              u[i] = {
                                ...u[i],
                                scenarioLabel: v || "",
                                scenario: sc ? scenarioToKey(sc) : u[i].scenario || "base",
                                value: amt != null ? amt : u[i].value,
                              };
                              setSpThresholds(u);
                            }}
                            options={scenarioOptionLabels}
                            renderInput={(p) => <TextField {...p} label="Scenario" />}
                            disableClearable
                          />
                          <TextField
                            size="small"
                            label="What it represents (%, USD, rating…)"
                            sx={{ width: 220 }}
                            value={t.description || ""}
                            onChange={(e) => {
                              const u = [...spThresholds];
                              u[i] = { ...u[i], description: e.target.value };
                              setSpThresholds(u);
                            }}
                          />
                          <MDButton
                            size="small"
                            variant="text"
                            color="error"
                            onClick={() => setSpThresholds(spThresholds.filter((_, j) => j !== i))}
                          >
                            Remove
                          </MDButton>
                        </MDBox>
                      ))}
                      <MDButton
                        size="small"
                        variant="outlined"
                        sx={{ color: "#52009b", borderColor: "#52009b", mt: 1 }}
                        onClick={() =>
                          setSpThresholds([
                            ...spThresholds,
                            {
                              value: 0,
                              direction: "above",
                              scenario: "base",
                              scenarioLabel: "",
                              description: "",
                            },
                          ])
                        }
                      >
                        + Add Threshold
                      </MDButton>
                    </Grid>
                  )}

                  {/* ── Qualitative: trigger builder ── */}
                  {signpostSubType === "qualitative" && (
                    <Grid item xs={12}>
                      <MDTypography variant="h6" sx={{ color: "#52009b" }} gutterBottom>
                        Trigger Conditions
                      </MDTypography>
                      {spTriggers.map((t, i) => (
                        <MDBox
                          key={i}
                          display="flex"
                          gap={1}
                          alignItems="flex-start"
                          mb={1}
                          flexWrap="wrap"
                        >
                          <Autocomplete
                            size="small"
                            sx={{ width: 220 }}
                            value={
                              t.triggerType === "residual_threshold"
                                ? "Residual-risk threshold"
                                : "Trigger event"
                            }
                            onChange={(_, v) => {
                              const u = [...spTriggers];
                              u[i] = {
                                ...u[i],
                                triggerType:
                                  v === "Residual-risk threshold" ? "residual_threshold" : "event",
                              };
                              setSpTriggers(u);
                            }}
                            options={["Trigger event", "Residual-risk threshold"]}
                            renderInput={(p) => <TextField {...p} label="Type" />}
                            disableClearable
                          />
                          <TextField
                            size="small"
                            label={
                              t.triggerType === "residual_threshold"
                                ? "Threshold condition (e.g. exposure exceeds appetite)"
                                : "Trigger event description"
                            }
                            multiline
                            sx={{ width: 380 }}
                            value={t.description}
                            onChange={(e) => {
                              const u = [...spTriggers];
                              u[i] = {
                                ...u[i],
                                description: e.target.value,
                                // mirror into thresholdCondition for residual-threshold triggers
                                ...(u[i].triggerType === "residual_threshold"
                                  ? { thresholdCondition: e.target.value }
                                  : {}),
                              };
                              setSpTriggers(u);
                            }}
                          />
                          <Autocomplete
                            size="small"
                            sx={{ width: 180 }}
                            value={t.scenarioLabel || ""}
                            onChange={(_, v) => {
                              const u = [...spTriggers];
                              const sc = findScenarioByLabel(v);
                              u[i] = {
                                ...u[i],
                                scenarioLabel: v || "",
                                scenario: sc ? scenarioToKey(sc) : u[i].scenario || "base",
                              };
                              setSpTriggers(u);
                            }}
                            options={scenarioOptionLabels}
                            renderInput={(p) => <TextField {...p} label="Scenario" />}
                            disableClearable
                          />
                          <TextField
                            size="small"
                            label="Context Notes (opt)"
                            sx={{ width: 260 }}
                            value={t.contextNotes || ""}
                            onChange={(e) => {
                              const u = [...spTriggers];
                              u[i] = { ...u[i], contextNotes: e.target.value };
                              setSpTriggers(u);
                            }}
                          />
                          <MDButton
                            size="small"
                            variant="text"
                            color="error"
                            onClick={() => setSpTriggers(spTriggers.filter((_, j) => j !== i))}
                          >
                            Remove
                          </MDButton>
                        </MDBox>
                      ))}
                      <MDButton
                        size="small"
                        variant="outlined"
                        sx={{ color: "#52009b", borderColor: "#52009b", mt: 1 }}
                        onClick={() =>
                          setSpTriggers([
                            ...spTriggers,
                            {
                              description: "",
                              scenario: "base",
                              scenarioLabel: "",
                              contextNotes: "",
                              triggerType: "event",
                              thresholdCondition: "",
                            },
                          ])
                        }
                      >
                        + Add Trigger
                      </MDButton>
                    </Grid>
                  )}
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        ) : !showSignPost ? (
          <Grid
            style={{
              backgroundColor: "white",
              borderRadius: "5px",
              padding: "15px",
              minHeight: "520px",
            }}
          >
            <Grid item md={12}>
              <MDBox alignItems="center" justifyContent="space-between" px={2} pt={2} pb={0.5}>
                <MDTypography variant="h5">Watchlist Risks</MDTypography>
                <MDTypography variant="body2">
                  You can click on the emerging risk to view the details
                </MDTypography>
              </MDBox>
            </Grid>
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2, mb: 1 }}>
              <Tabs value={watchlistTab} onChange={(_, v) => setWatchlistTab(v)}>
                <Tab label="Radar" />
                <Tab label="Summary" />
              </Tabs>
            </Box>
            {watchlistTab === 1 && (
              <WatchlistSummary
                execute={execute}
                onOpenRisk={(id) => {
                  const r = (riskDetailsData || []).find(
                    (x) => String(x.id || x._id) === String(id)
                  );
                  if (r) handleSignPost(r);
                }}
              />
            )}
            {watchlistTab === 0 && (
              <Grid container direction="column">
                <Grid item container columns="16">
                  <Grid item xs={16}>
                    <EmergingRiskRadar
                      embedded
                      onOpenRisk={(item) => {
                        const normalized = {
                          ...item,
                          id: item.id || (item._id && String(item._id)),
                        };
                        setRiskDetails(normalized);
                        setSelectedCategory(item.Category || "");
                        setSelectedSubCategory(item.SubCategory || "");
                        setTimeFrame(item.timeFrame || "medium-term");
                        setLikelihood(item.likelihood || "");
                        setLinkedHorizonTheme(item.linkedHorizonTheme || "");
                        const matched = allSubCats.find((s) => s.Category === item.Category);
                        if (matched) setSubCategories(matched.SubCategory || []);
                        loadScenariosFromRisk(normalized);
                        setCreateRisk(false);
                        setShowSignPost(true);
                        setEditMode(false);
                        setJustCreated(false);
                        setValue(0);
                      }}
                      onCreateRisk={() => {
                        setCreateRisk(true);
                        setRiskDetails({});
                        setActiveStep(0);
                        setOverallVelocity("");
                        setScenarios([
                          {
                            id: "sc_best",
                            label: "Best Case",
                            velocity: "",
                            threatOpp: "gain",
                            consequenceAmt: "",
                            qualitative: "",
                            responseStatus: "",
                          },
                          {
                            id: "sc_worst",
                            label: "Worst Case",
                            velocity: "",
                            threatOpp: "loss",
                            consequenceAmt: "",
                            qualitative: "",
                            responseStatus: "",
                          },
                        ]);
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={0}
                    style={{
                      display:
                        "none" /* kept as placeholder to avoid restructuring surrounding Grid */,
                    }}
                  >
                    <MDBox
                      display="flex"
                      alignItems="center"
                      flexDirection="row"
                      justifyContent="space-between"
                      px={2}
                    >
                      <MDTypography variant="body2" gutterBottom>
                        Select Scenario
                      </MDTypography>
                      <RadioGroup
                        row
                        aria-label="scenario"
                        name="scenario"
                        value={scenario}
                        onChange={handleScenarioChange}
                      >
                        <FormControlLabel value="Base" control={<Radio />} label="Base" />
                        <FormControlLabel
                          value="Pessimistic"
                          control={<Radio />}
                          label="Worst case"
                        />
                        <FormControlLabel
                          value="Optimistic"
                          control={<Radio />}
                          label="Best case"
                        />
                      </RadioGroup>
                    </MDBox>
                    <MDBox alignItems="center" justifyContent="space-between" px={2} py={2}>
                      <MDBox
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          pt: 2,
                          justifyContent: "flex-end",
                        }}
                      >
                        {" "}
                        <MDButton
                          variant="text"
                          color="black"
                          onClick={() => {
                            setCreateRisk(true);
                            setRiskDetails({});
                            setActiveStep(0);
                            setOverallVelocity("");
                            setScenarios([
                              {
                                id: "sc_best",
                                label: "Best Case",
                                velocity: "",
                                threatOpp: "gain",
                                consequenceAmt: "",
                                qualitative: "",
                                responseStatus: "",
                              },
                              {
                                id: "sc_worst",
                                label: "Worst Case",
                                velocity: "",
                                threatOpp: "loss",
                                consequenceAmt: "",
                                qualitative: "",
                                responseStatus: "",
                              },
                            ]);
                          }}
                          sx={{ color: "#52009b" }}
                        >
                          +Create Risk
                        </MDButton>
                        <MDButton
                          variant="text"
                          color="black"
                          startIcon={<ArticleIcon />}
                          onClick={() => navigate("/anticipate/board-paper")}
                          sx={{ color: "#52009b" }}
                        >
                          Board Paper
                        </MDButton>
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              checked={showDrafts}
                              onChange={(e) => setShowDrafts(e.target.checked)}
                            />
                          }
                          label={<MDTypography variant="caption">Show drafts</MDTypography>}
                          sx={{ ml: 1 }}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              checked={showArchived}
                              onChange={(e) => {
                                setShowArchived(e.target.checked);
                                if (e.target.checked) loadArchived();
                              }}
                            />
                          }
                          label={
                            <MDTypography variant="caption">
                              Show archived
                              {archivedRisks.length ? ` (${archivedRisks.length})` : ""}
                            </MDTypography>
                          }
                          sx={{ ml: 1 }}
                        />
                      </MDBox>
                      {renderArchivedPanel()}
                      {(() => {
                        // Number active risks by severity (worst-case magnitude) so the list
                        // matches the radar's numbered balls. Drafts get no number (not on radar).
                        const sevOf = (r) =>
                          Math.max(
                            ...[
                              "optimisticConsequenceAmt",
                              "baseConsequenceAmt",
                              "pessimisticConsequenceAmt",
                            ].map((k) => parseMoney(r[k]))
                          );
                        const dno = {};
                        riskDetailsData
                          .filter((r) => r.status === "active")
                          .slice()
                          .sort(
                            (a, b) =>
                              sevOf(b) - sevOf(a) ||
                              String(a.id || a._id).localeCompare(String(b.id || b._id))
                          )
                          .forEach((r, i) => {
                            dno[r.id || r._id] = i + 1;
                          });
                        const visible = riskDetailsData.filter(
                          (r) => showDrafts || r.status === "active"
                        );
                        return visible.map((item) => {
                          const isDraft = item.status !== "active";
                          const displayNo = dno[item.id || item._id];
                          return (
                            <Accordion
                              key={item.id || item._id}
                              sx={{ opacity: isDraft ? 0.6 : 1 }}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <MDBox display="flex" alignItems="center" gap={1} width="100%">
                                  {displayNo != null && (
                                    <MDBox
                                      sx={{
                                        flexShrink: 0,
                                        minWidth: 22,
                                        height: 22,
                                        px: "4px",
                                        borderRadius: "11px",
                                        bgcolor: "#52009b",
                                        color: "#fff",
                                        fontSize: "0.72rem",
                                        fontWeight: 700,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {displayNo}
                                    </MDBox>
                                  )}
                                  <MDTypography
                                    sx={{ flex: 1, fontStyle: isDraft ? "italic" : "normal" }}
                                  >
                                    {item.Title}
                                  </MDTypography>
                                  {item.trendDirection && (
                                    <MuiTooltip
                                      title={
                                        item.trendDirection === "pessimistic"
                                          ? "Signposts are worsening"
                                          : item.trendDirection === "optimistic"
                                          ? "Signposts are improving"
                                          : "Signposts show mixed signals — some worsening, some improving"
                                      }
                                    >
                                      <Chip
                                        size="small"
                                        label={
                                          item.trendDirection === "pessimistic"
                                            ? "⚠ Worsening"
                                            : item.trendDirection === "optimistic"
                                            ? "✓ Improving"
                                            : "~ Mixed"
                                        }
                                        sx={{
                                          fontSize: "11px",
                                          bgcolor:
                                            item.trendDirection === "pessimistic"
                                              ? "#f57c00"
                                              : item.trendDirection === "optimistic"
                                              ? "#388e3c"
                                              : "#8e24aa",
                                          color: "#fff",
                                        }}
                                      />
                                    </MuiTooltip>
                                  )}
                                  <MuiTooltip
                                    title={
                                      item.status === "active"
                                        ? "Active — click to move to Draft"
                                        : "Draft — click to Publish"
                                    }
                                  >
                                    <Chip
                                      label={item.status === "active" ? "Active" : "Draft"}
                                      size="small"
                                      color={item.status === "active" ? "success" : "default"}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleActivateRisk(item.id || item._id, item.status);
                                      }}
                                      sx={{ cursor: "pointer" }}
                                    />
                                  </MuiTooltip>
                                  {/* ID172 — show the likelihood band or the time horizon by mode. */}
                                  {(isLikelihoodMode ? item.likelihood : item.timeFrame) && (
                                    <Chip
                                      label={isLikelihoodMode ? item.likelihood : item.timeFrame}
                                      size="small"
                                      variant="outlined"
                                      sx={{ fontSize: "11px" }}
                                    />
                                  )}
                                </MDBox>
                              </AccordionSummary>
                              <AccordionDetails>
                                <MDTypography>{item.Description}</MDTypography>
                                {item.linkedHorizonTheme && (
                                  <MDTypography variant="caption" color="text.secondary">
                                    Linked theme: {item.linkedHorizonTheme}
                                  </MDTypography>
                                )}
                                <MDTypography variant="h6" sx={{ mt: 1 }}>
                                  Base Scenario
                                </MDTypography>
                                <MDTypography variant="body2">
                                  {"-> "}
                                  {item.baseResponseStatus}
                                </MDTypography>
                                <MDTypography variant="body2">
                                  {"-> "}
                                  {item.baseVelocity}
                                </MDTypography>
                                <MDTypography variant="body2">
                                  {"-> "}
                                  {item.baseQualitative}
                                </MDTypography>
                                <MDBox display="flex">
                                  <MDButton
                                    variant="text"
                                    color="black"
                                    sx={{ color: "#52009b" }}
                                    onClick={() => {
                                      const normalized = {
                                        ...item,
                                        id: item.id || (item._id && String(item._id)),
                                      };
                                      setRiskDetails(normalized);
                                      setSelectedCategory(item.Category || "");
                                      setSelectedSubCategory(item.SubCategory || "");
                                      setTimeFrame(item.timeFrame || "medium-term");
                                      setLikelihood(item.likelihood || "");
                                      setLinkedHorizonTheme(item.linkedHorizonTheme || "");
                                      const matched = allSubCats.find(
                                        (s) => s.Category === item.Category
                                      );
                                      if (matched) setSubCategories(matched.SubCategory || []);
                                      loadScenariosFromRisk(normalized);
                                      setCreateRisk(false);
                                      setShowSignPost(true);
                                      setJustCreated(false);
                                      setValue(0);
                                    }}
                                  >
                                    Risk Details
                                  </MDButton>
                                  <MDButton
                                    variant="text"
                                    color="black"
                                    sx={{ color: "#52009b" }}
                                    onClick={() => {
                                      handleSignPost(item);
                                    }}
                                  >
                                    Sign Posts
                                  </MDButton>
                                </MDBox>
                              </AccordionDetails>
                            </Accordion>
                          );
                        });
                      })()}
                    </MDBox>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        ) : (
          ""
        )}
      </form>
      {showSignPost ? (
        <Grid
          style={{
            backgroundColor: "white",
            borderRadius: "5px",
            padding: "15px",
            minHeight: "520px",
          }}
        >
          {" "}
          <MDBox sx={{ width: "100%" }}>
            <MDBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                // ID164 — keep the title + Save/Discard bar visible while scrolling this long page,
                // so the user never loses the Save button.
                position: "sticky",
                top: 0,
                zIndex: 1100,
                bgcolor: "#fff",
              }}
            >
              {/* ID89 — tabs merged into one page; show the risk title as the heading */}
              <MDBox sx={{ flex: 1, py: 2, px: 1 }}>
                <MDTypography variant="h5" sx={{ color: "#52009b", fontWeight: 700 }}>
                  {RiskDetails.Title || "Risk Details"}
                </MDTypography>
                {RiskDetails.status && (
                  <Chip
                    size="small"
                    label={
                      RiskDetails.status === "active"
                        ? "Active"
                        : RiskDetails.status === "archived"
                        ? `Closed / Archived${
                            RiskDetails.closedReason ? ` · ${RiskDetails.closedReason}` : ""
                          }`
                        : "Draft"
                    }
                    sx={{
                      mt: 0.5,
                      fontSize: 11,
                      color: "#fff",
                      bgcolor:
                        RiskDetails.status === "active"
                          ? "#388e3c"
                          : RiskDetails.status === "archived"
                          ? "#8a6300"
                          : "#9e9e9e",
                    }}
                  />
                )}
              </MDBox>
              <MDBox display="flex" alignItems="center" gap={1} pr={1}>
                {!createRisk && editMode && (
                  <>
                    <MDButton
                      backgroundColor="#52009b"
                      variant="contained"
                      color="#52009b"
                      size="small"
                      startIcon={<SaveIcon />}
                      onClick={() => {
                        handleSaveAll();
                        setEditMode(false);
                        setSaveSuccess(true);
                        setTimeout(() => setSaveSuccess(false), 3000);
                      }}
                      sx={{ color: "#f7f4fb" }}
                    >
                      Save
                    </MDButton>
                    <MDButton
                      variant="outlined"
                      size="small"
                      startIcon={<UndoIcon />}
                      onClick={() => {
                        if (originalSnapshot.current) {
                          setRiskDetails(originalSnapshot.current.riskDetails);
                          setScenarios(originalSnapshot.current.scenarios);
                        }
                        setEditMode(false);
                        setEditingSpDrafts({});
                      }}
                      sx={{ color: "#52009b", borderColor: "#52009b", textTransform: "none" }}
                    >
                      Discard
                    </MDButton>
                  </>
                )}
                {!createRisk && !editMode && (
                  <>
                    {/* "See Horizon Scan Stream" button removed on request. */}
                    <MDButton
                      size="small"
                      variant={RiskDetails.status === "active" ? "outlined" : "contained"}
                      backgroundColor={RiskDetails.status === "active" ? undefined : "#52009b"}
                      onClick={() =>
                        handleActivateRisk(
                          RiskDetails.id || (RiskDetails._id && String(RiskDetails._id))
                        )
                      }
                      sx={
                        RiskDetails.status === "active"
                          ? { color: "#52009b", borderColor: "#52009b", textTransform: "none" }
                          : {
                              color: "#f7f4fb",
                              bgcolor: "#52009b",
                              textTransform: "none",
                              "&:hover": { bgcolor: "#3a0070" },
                            }
                      }
                    >
                      {RiskDetails.status === "active" ? "Set to Draft" : "Activate"}
                    </MDButton>
                    <MuiTooltip title="Modify">
                      <IconButton
                        size="small"
                        onClick={() => {
                          originalSnapshot.current = {
                            riskDetails: { ...RiskDetails },
                            scenarios: scenarios.map((s) => ({ ...s })),
                          };
                          setEditMode(true);
                        }}
                      >
                        <EditIcon fontSize="small" sx={{ color: "#52009b" }} />
                      </IconButton>
                    </MuiTooltip>
                    {RiskDetails.status === "archived" ? (
                      <MuiTooltip title="Restore from archive (back to draft)">
                        <MDButton
                          size="small"
                          variant="outlined"
                          startIcon={<RestoreIcon fontSize="small" />}
                          onClick={() => requestRestore(RiskDetails)}
                          sx={{ color: "#2c7a50", borderColor: "#2c7a50", textTransform: "none" }}
                        >
                          Restore
                        </MDButton>
                      </MuiTooltip>
                    ) : (
                      <MuiTooltip title="Close / archive this risk (end of life — retained & restorable)">
                        <MDButton
                          size="small"
                          variant="outlined"
                          startIcon={<ArchiveIcon fontSize="small" />}
                          onClick={() => setArchiveDialogOpen(true)}
                          sx={{ color: "#8a6300", borderColor: "#8a6300", textTransform: "none" }}
                        >
                          Close / Archive
                        </MDButton>
                      </MuiTooltip>
                    )}
                    {/* Archive warning + mandatory free-text reason (recovery note included) */}
                    <Dialog
                      open={archiveDialogOpen}
                      onClose={() => setArchiveDialogOpen(false)}
                      maxWidth="xs"
                      fullWidth
                    >
                      <DialogTitle sx={{ color: "#8a6300", fontWeight: 700 }}>
                        Close / Archive this risk?
                      </DialogTitle>
                      <DialogContent>
                        <MDTypography variant="body2" sx={{ mb: 1.5 }}>
                          This ends the risk&apos;s active life and removes it from the Watch List
                          and radar. Archived risks are <b>retained and can be restored</b> later
                          from the &quot;Show archived&quot; panel in the Watch List.
                        </MDTypography>
                        <TextField
                          autoFocus
                          fullWidth
                          required
                          multiline
                          minRows={2}
                          label="Reason for archiving"
                          placeholder="Why is this risk being closed/archived?"
                          value={archiveReasonText}
                          onChange={(e) => setArchiveReasonText(e.target.value)}
                        />
                      </DialogContent>
                      <DialogActions>
                        <MDButton
                          variant="text"
                          onClick={() => setArchiveDialogOpen(false)}
                          sx={{ textTransform: "none" }}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="contained"
                          disabled={!archiveReasonText.trim()}
                          onClick={() =>
                            handleArchiveRisk(
                              RiskDetails.id || (RiskDetails._id && String(RiskDetails._id)),
                              archiveReasonText.trim()
                            )
                          }
                          sx={{
                            bgcolor: "#8a6300",
                            color: "#fff",
                            textTransform: "none",
                            "&:hover": { bgcolor: "#6e4f00" },
                          }}
                        >
                          Close / Archive
                        </MDButton>
                      </DialogActions>
                    </Dialog>
                    {/* Delete warning confirmation (styled — matches the archive dialog) */}
                    <Dialog
                      open={deleteDialogOpen}
                      onClose={() => setDeleteDialogOpen(false)}
                      maxWidth="xs"
                      fullWidth
                    >
                      <DialogTitle sx={{ color: "#b71c1c", fontWeight: 700 }}>
                        Delete this risk?
                      </DialogTitle>
                      <DialogContent>
                        <MDTypography variant="body2">
                          This <b>permanently deletes</b> the risk and <b>cannot be undone</b>. All
                          corresponding signposts and their data feeds are deleted too. If you might
                          need it later, use <b>Close / Archive</b> instead — archived risks are
                          retained and can be restored.
                        </MDTypography>
                      </DialogContent>
                      <DialogActions>
                        <MDButton
                          variant="text"
                          onClick={() => setDeleteDialogOpen(false)}
                          sx={{ textTransform: "none" }}
                        >
                          Cancel
                        </MDButton>
                        <MDButton
                          variant="contained"
                          onClick={() =>
                            performDeleteRisk(
                              RiskDetails.id || (RiskDetails._id && String(RiskDetails._id))
                            )
                          }
                          sx={{
                            bgcolor: "#b71c1c",
                            color: "#fff",
                            textTransform: "none",
                            "&:hover": { bgcolor: "#8e1414" },
                          }}
                        >
                          Delete permanently
                        </MDButton>
                      </DialogActions>
                    </Dialog>
                    <MuiTooltip title="Delete">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDeleteRiskDetails()}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </MuiTooltip>
                  </>
                )}
                <MDButton
                  variant="text"
                  color="black"
                  sx={{ color: "#52009b", mr: 1 }}
                  onClick={() => {
                    setShowSignPost(false);
                    setCreateRisk(false);
                    setRiskDetails({});
                    setEditMode(false);
                    setJustCreated(false);
                  }}
                >
                  ← Back to List
                </MDButton>
              </MDBox>
            </MDBox>
            {saveSuccess && (
              <MDAlert color="success" dismissible sx={{ mx: 2, mt: 1 }}>
                Record saved successfully.
              </MDAlert>
            )}
            {/* ID77 — live publish checklist: show what's still required (or that it's ready)
                while the record is a draft, mirroring the server-side activation guard. */}
            {RiskDetails.status !== "active" &&
              (getPublishMissing().length > 0 ? (
                <MDBox
                  sx={{
                    mx: 2,
                    mt: 1,
                    p: 1.5,
                    borderRadius: "6px",
                    bgcolor: "#fff8e1",
                    border: "1px solid #ffe082",
                  }}
                >
                  <MDTypography
                    variant="button"
                    sx={{ fontWeight: 700, color: "#8a6d00", display: "block" }}
                  >
                    Required before this risk can be published to the radar:
                  </MDTypography>
                  <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
                    {getPublishMissing().map((m) => (
                      <Box
                        component="li"
                        key={m}
                        sx={{ color: "#8a6d00", fontSize: 13, lineHeight: 1.6 }}
                      >
                        {m}
                      </Box>
                    ))}
                  </Box>
                </MDBox>
              ) : (
                <MDBox
                  sx={{
                    mx: 2,
                    mt: 1,
                    p: 1,
                    borderRadius: "6px",
                    bgcolor: "#e8f5e9",
                    border: "1px solid #a5d6a7",
                  }}
                >
                  <MDTypography variant="button" sx={{ fontWeight: 700, color: "#2e7d32" }}>
                    ✓ All required fields complete — ready to publish (add a signpost if you
                    haven&apos;t, then click Activate).
                  </MDTypography>
                </MDBox>
              ))}
            <MDBox sx={{ px: 1, pt: 1 }}>
              {editMode || createRisk ? (
                <Box>
                  <Grid container spacing={4} sx={{ pl: "8px", pb: "90px" }}>
                    <Grid item md={12} sx={12} sm={12} xs={12} lg={12}>
                      <TextField
                        label="Title"
                        variant="outlined"
                        name="Title"
                        sx={{ width: "30%", marginRight: "10px" }}
                        value={RiskDetails.Title || ""}
                        onChange={handleRiskDetailsChange}
                        required
                        error={!!formErrors.Title}
                        helperText={formErrors.Title}
                      />
                      <TextField
                        label="Description"
                        variant="outlined"
                        name="Description"
                        sx={{ width: "60%" }}
                        value={RiskDetails.Description || ""}
                        onChange={handleRiskDetailsChange}
                        required
                        error={!!formErrors.Description}
                        helperText={formErrors.Description}
                      />
                      <br />
                    </Grid>
                    <Grid item md={12} sx={12} sm={12} xs={12} lg={12}>
                      {allSubCats ? (
                        <MDBox display="flex">
                          <Autocomplete
                            sx={{ width: "30%", marginRight: "10px" }}
                            value={selectedCategory || ""}
                            onChange={(event, newValue) => handleCategoryChange(event, newValue)}
                            options={allSubCats.map((item) => item.Category)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Category"
                                variant="outlined"
                                width="30%"
                              />
                            )}
                          />
                          <Autocomplete
                            sx={{ width: "30%" }}
                            value={selectedSubCategory || ""}
                            onChange={(event, newValue) => handleSubCategoryChange(event, newValue)}
                            options={subCategories}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category"
                                variant="outlined"
                                width="30%"
                              />
                            )}
                          />
                        </MDBox>
                      ) : (
                        ""
                      )}
                    </Grid>
                    {/* Likelihood picker + "Populate with AI" button removed (PO 2026-09-18): the
                        assessment is populated automatically by AI. */}
                    <Grid item md={12}>
                      <Divider
                        sx={{
                          m: "10px",
                          borderWidth: "1.5px",
                          color: "black",
                          mt: "15px",
                          width: "100%",
                        }}
                      />
                    </Grid>
                    <Grid container columns={12} spacing={2}>
                      {scenarios.map((sc, scIdx) => (
                        <Grid item md={12} xs={12} key={sc.id}>
                          <Card
                            sx={{
                              padding: 2,
                              position: "relative",
                              mb: 2,
                              borderLeft: `6px solid ${
                                scIdx === 0 ? "#2e7d32" : scIdx === 1 ? "#c62828" : "#52009b"
                              }`,
                              bgcolor:
                                scIdx === 0 ? "#f3faf4" : scIdx === 1 ? "#fdf5f5" : "#faf8fc",
                            }}
                          >
                            {scIdx >= 2 && (editMode || createRisk) && (
                              <MDButton
                                size="small"
                                variant="text"
                                color="error"
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  minWidth: "auto",
                                  p: "2px 6px",
                                }}
                                onClick={() => removeScenario(scIdx)}
                              >
                                ✕
                              </MDButton>
                            )}
                            {(editMode || createRisk) && scIdx >= 2 ? (
                              <>
                                <MDTypography
                                  variant="h6"
                                  sx={{ color: "#52009b", fontWeight: 700, mb: 0.5 }}
                                >
                                  Scenario Name
                                </MDTypography>
                                <TextField
                                  value={sc.label}
                                  fullWidth
                                  size="small"
                                  onChange={(e) =>
                                    handleScenarioFieldChange(scIdx, "label", e.target.value)
                                  }
                                  sx={{ mb: 1 }}
                                />
                              </>
                            ) : (
                              <MDTypography
                                variant="h6"
                                sx={{ color: "#52009b", fontWeight: 700, mb: 1, textAlign: "left" }}
                              >
                                {sc.label}
                              </MDTypography>
                            )}
                            {renderScenarioDesc(scIdx, "labelDescription", sc.labelDescription)}
                            {/* Scenario as a table ROW — attributes laid out side by side. */}
                            <Box
                              sx={{
                                display: "flex",
                                gap: 2,
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                              }}
                            >
                              <Box sx={{ flex: "1 1 460px", minWidth: 300 }}>
                                {/* ID81 — Consequence direction + quantitative/qualitative in one box */}
                                <Box
                                  sx={{
                                    border: "1px solid rgba(82,0,155,0.25)",
                                    borderRadius: 1,
                                    p: 1.5,
                                    mb: 1,
                                  }}
                                >
                                  <MDTypography
                                    variant="h6"
                                    sx={{ pd: 2, color: "#52009b" }}
                                    gutterBottom
                                  >
                                    Consequence
                                  </MDTypography>
                                  <FormControl>
                                    <RadioGroup
                                      row
                                      defaultValue="loss"
                                      value={sc.threatOpp || "loss"}
                                      onChange={(_, newValue) =>
                                        handleScenarioFieldChange(
                                          scIdx,
                                          "threatOpp",
                                          newValue ?? "loss"
                                        )
                                      }
                                      sx={{ pd: 2 }}
                                    >
                                      <FormControlLabel
                                        value="loss"
                                        control={<Radio />}
                                        label="Threat/Loss"
                                      />
                                      <FormControlLabel
                                        value="gain"
                                        control={<Radio />}
                                        label="Opportunity/Gain"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {/* Qualitative is the default; a toggle switches to quantitative. Only
                                  the chosen block shows — simpler than stacking both. */}
                                  <Box sx={{ display: "flex", gap: 1, mt: 1, mb: 1.5 }}>
                                    {[
                                      { v: "qualitative", l: "Qualitative" },
                                      { v: "quantitative", l: "Quantitative" },
                                    ].map((opt) => (
                                      <MDButton
                                        key={opt.v}
                                        size="small"
                                        variant={
                                          (sc.consequenceMode || "qualitative") === opt.v
                                            ? "contained"
                                            : "outlined"
                                        }
                                        color={
                                          (sc.consequenceMode || "qualitative") === opt.v
                                            ? "info"
                                            : "secondary"
                                        }
                                        onClick={() =>
                                          handleScenarioFieldChange(scIdx, "consequenceMode", opt.v)
                                        }
                                        sx={{
                                          textTransform: "none",
                                          minWidth: 0,
                                          px: 1.5,
                                          py: 0.25,
                                        }}
                                      >
                                        {opt.l}
                                      </MDButton>
                                    ))}
                                  </Box>
                                  {(sc.consequenceMode || "qualitative") === "quantitative" ? (
                                    <>
                                      <TextField
                                        label="Enter Amount($)"
                                        variant="outlined"
                                        // ID83 — threat/loss shows a red "−" prefix; opportunity/gain a black "+".
                                        sx={{
                                          width: "60%",
                                          "& input": {
                                            color: sc.threatOpp === "gain" ? "#000" : "#d32f2f",
                                          },
                                        }}
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <span
                                                style={{
                                                  color:
                                                    sc.threatOpp === "gain" ? "#000" : "#d32f2f",
                                                  fontWeight: 700,
                                                }}
                                              >
                                                {sc.threatOpp === "gain" ? "+" : "−"}
                                              </span>
                                            </InputAdornment>
                                          ),
                                        }}
                                        value={sc.consequenceAmt || ""}
                                        onChange={(e) =>
                                          handleScenarioFieldChange(
                                            scIdx,
                                            "consequenceAmt",
                                            e.target.value
                                          )
                                        }
                                      />
                                      {renderScenarioDesc(
                                        scIdx,
                                        "consequenceAmtDescription",
                                        sc.consequenceAmtDescription
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {renderConsequences(sc, scIdx)}
                                      {renderScenarioDesc(
                                        scIdx,
                                        "qualitativeDescription",
                                        sc.qualitativeDescription
                                      )}
                                    </>
                                  )}
                                </Box>
                              </Box>
                              <Box sx={{ flex: "1 1 240px", minWidth: 200 }}>
                                <MDTypography
                                  variant="h6"
                                  gutterBottom
                                  sx={{ pd: 2, color: "#52009b" }}
                                >
                                  Response Status
                                </MDTypography>
                                <Autocomplete
                                  sx={{ pd: 2 }}
                                  value={sc.responseStatus || ""}
                                  onChange={(_, newValue) =>
                                    handleScenarioFieldChange(
                                      scIdx,
                                      "responseStatus",
                                      newValue?.label ?? ""
                                    )
                                  }
                                  options={responseStatusOptions}
                                  renderInput={(params) => (
                                    <TextField {...params} variant="outlined" />
                                  )}
                                />
                                {renderScenarioDesc(
                                  scIdx,
                                  "responseStatusDescription",
                                  sc.responseStatusDescription
                                )}
                              </Box>
                            </Box>
                          </Card>
                        </Grid>
                      ))}
                      {(editMode || createRisk) && (
                        <Grid item xs={12}>
                          <MDButton
                            variant="outlined"
                            sx={{ color: "#52009b", borderColor: "#52009b", mt: 1 }}
                            onClick={addScenario}
                          >
                            + Add Scenario
                          </MDButton>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <>
                  {/* Board-ready summary: mini best↔worst radar gauge (left) + scenario/trending
                      table (right). Fed the server-shaped risk so it matches the portfolio radar. */}
                  {radarRisk && (
                    <Grid container spacing={2} sx={{ mb: 2, alignItems: "flex-start" }}>
                      <Grid item xs={12} md={4}>
                        <Card sx={{ p: 2 }}>
                          <MDTypography
                            variant="subtitle2"
                            fontWeight="bold"
                            sx={{ color: "#52009b", mb: 1 }}
                          >
                            Current state
                          </MDTypography>
                          <MiniRiskGauge
                            scenarioRows={radarRisk.scenarioRows}
                            proximity={radarRisk.signpostProximity}
                            plausibilityLabel={
                              isLikelihoodMode ? likelihood || radarRisk.likelihood || "" : ""
                            }
                            direction={RiskDetails.overallSignalTrend?.direction}
                            bestSigned={
                              radarRisk.scenarios?.optimistic?.threatOpp === "opportunity"
                                ? Number(radarRisk.scenarios?.optimistic?.value || 0)
                                : -Number(radarRisk.scenarios?.optimistic?.value || 0)
                            }
                            worstSigned={
                              radarRisk.scenarios?.pessimistic?.threatOpp === "opportunity"
                                ? Number(radarRisk.scenarios?.pessimistic?.value || 0)
                                : -Number(radarRisk.scenarios?.pessimistic?.value || 0)
                            }
                            onProximityChange={(p) => setManualBallPosition(p)}
                          />
                          {/* Revert affordance relocated here when the "AI signal & radar position"
                              box was removed — a manual drag can still be reset to the AI position. */}
                          {typeof RiskDetails.overallSignalTrend?.manualProximity === "number" && (
                            <MDBox sx={{ mt: 1, textAlign: "center" }}>
                              <MDTypography
                                variant="caption"
                                sx={{ color: "#8a6300", fontWeight: 600, display: "block" }}
                              >
                                Position manually over-ridden.
                              </MDTypography>
                              <MDButton
                                size="small"
                                variant="text"
                                sx={{ color: "#52009b", textTransform: "none" }}
                                onClick={() => setManualBallPosition(null)}
                              >
                                Revert to AI position
                              </MDButton>
                            </MDBox>
                          )}
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <Card sx={{ p: 2 }}>
                          <MDTypography
                            variant="subtitle2"
                            fontWeight="bold"
                            sx={{ color: "#52009b", mb: 1 }}
                          >
                            Scenario assessment
                          </MDTypography>
                          <RiskSummaryPanel
                            risk={radarRisk}
                            isLikelihoodMode={isLikelihoodMode}
                            likelihood={likelihood || radarRisk.likelihood || ""}
                          />
                        </Card>
                        {/* ID214 — single "Live monitoring summary with history" below the scenario table:
                      the new AI position summary on top, then the commentary history + add-note. */}
                        <Card sx={{ p: 2, mt: 2, mb: 2 }}>
                          <MDBox
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              mb: 1,
                            }}
                          >
                            <MDTypography variant="subtitle2" fontWeight="bold">
                              Live monitoring summary
                            </MDTypography>
                            {(RiskDetails.commentary || []).length > 0 && (
                              <MDButton
                                size="small"
                                variant="text"
                                sx={{ color: "#52009b", textTransform: "none", minWidth: 0, px: 1 }}
                                onClick={() =>
                                  setCommentaryTab(
                                    commentaryTab === "history" ? "latest" : "history"
                                  )
                                }
                              >
                                {commentaryTab === "history"
                                  ? "Hide history"
                                  : `Show history (${(RiskDetails.commentary || []).length})`}
                              </MDButton>
                            )}
                          </MDBox>
                          {/* When the ball has been manually over-ridden, the displayed position differs from
                        the AI's — say so, so the summary (the automated view) doesn't look contradictory. */}
                          {typeof RiskDetails.overallSignalTrend?.manualProximity === "number" && (
                            <MDTypography
                              variant="caption"
                              sx={{ display: "block", color: "#8a6300", fontWeight: 600, mb: 1 }}
                            >
                              Position manually set to{" "}
                              {Math.round(
                                (1 - RiskDetails.overallSignalTrend.manualProximity) * 100
                              )}
                              % to worst case. The summary below is the automated signal assessment.
                            </MDTypography>
                          )}
                          {/* The SINGLE AI summary — the position-specific LLM summary (ID214). The commentary
                        trail is kept as collapsible history below, so there's only one summary on show. */}
                          {RiskDetails.overallSignalTrend?.positionSummary ||
                          RiskDetails.overallSignalTrend?.narrative ? (
                            <MDTypography
                              variant="body2"
                              sx={{ color: "#344767", fontSize: "0.85rem", lineHeight: 1.6 }}
                            >
                              {RiskDetails.overallSignalTrend?.positionSummary ||
                                RiskDetails.overallSignalTrend?.narrative}
                            </MDTypography>
                          ) : (
                            <MDTypography variant="caption" color="text.secondary">
                              Not yet assessed — add signposts or link a Horizon Scan theme, then
                              Reassess.
                            </MDTypography>
                          )}
                          {/* History trail — collapsed by default; expand to see past AI assessments + notes. */}
                          {commentaryTab === "history" &&
                            (RiskDetails.commentary || []).length > 0 && (
                              <MDBox sx={{ mt: 1.5, pt: 1.25, borderTop: "1px dashed #e7e2ee" }}>
                                <MDTypography
                                  variant="caption"
                                  sx={{
                                    color: "#7b809a",
                                    fontWeight: 700,
                                    display: "block",
                                    mb: 0.5,
                                  }}
                                >
                                  History
                                </MDTypography>
                                {[...(RiskDetails.commentary || [])].reverse().map((c) => (
                                  <MDBox
                                    key={c._id || c.createdAt}
                                    sx={{
                                      display: "flex",
                                      gap: 1,
                                      py: 0.75,
                                      borderBottom: "1px solid #efeaf6",
                                    }}
                                  >
                                    <span
                                      style={{
                                        flex: "none",
                                        marginTop: 2,
                                        fontSize: 10,
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                        color: c.authorType === "ai" ? "#52009b" : "#0a5bb0",
                                      }}
                                    >
                                      {c.authorType === "ai"
                                        ? "AI"
                                        : c.authorType === "external"
                                        ? "EXT"
                                        : "YOU"}
                                    </span>
                                    <MDBox sx={{ flex: 1 }}>
                                      <MDTypography
                                        variant="caption"
                                        sx={{ whiteSpace: "pre-wrap" }}
                                      >
                                        {c.text}
                                      </MDTypography>
                                      <MDTypography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", fontSize: 10 }}
                                      >
                                        {c.author || ""}
                                        {c.createdAt
                                          ? ` · ${new Date(c.createdAt).toLocaleString()}`
                                          : ""}
                                      </MDTypography>
                                    </MDBox>
                                    {c.authorType !== "ai" && (
                                      <IconButton
                                        size="small"
                                        onClick={() => handleDeleteComment(c._id)}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </MDBox>
                                ))}
                              </MDBox>
                            )}
                          <MDBox sx={{ display: "flex", gap: 1, mt: 1.25 }}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Add a note…"
                              value={commentInput}
                              onChange={(e) => setCommentInput(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                  e.preventDefault();
                                  handleAddComment();
                                }
                              }}
                            />
                            <MDButton
                              size="small"
                              variant="contained"
                              sx={{ bgcolor: "#52009b", color: "#fff" }}
                              onClick={handleAddComment}
                              disabled={!commentInput.trim()}
                            >
                              Add
                            </MDButton>
                          </MDBox>
                        </Card>
                      </Grid>
                    </Grid>
                  )}
                  {renderReadOnlyDetails()}
                </>
              )}
            </MDBox>
            {renderAttachmentsSection()}
            <MDBox sx={{ px: 1 }}>
              {(() => {
                const hasPess = activeSignposts.some(
                  (sp) => sp.lastAssessment?.trendScenario === "pessimistic"
                );
                const hasOpt = activeSignposts.some(
                  (sp) => sp.lastAssessment?.trendScenario === "optimistic"
                );
                const ot =
                  hasPess && hasOpt
                    ? "mixed"
                    : hasPess
                    ? "pessimistic"
                    : hasOpt
                    ? "optimistic"
                    : null;
                if (!ot) return null;
                return (
                  <MDBox
                    mx={2}
                    mt={2}
                    p={2}
                    sx={{
                      borderRadius: 2,
                      borderLeft: "4px solid",
                      borderColor:
                        ot === "pessimistic"
                          ? "#f57c00"
                          : ot === "optimistic"
                          ? "#388e3c"
                          : "#8e24aa",
                      bgcolor:
                        ot === "pessimistic"
                          ? "#fff8f0"
                          : ot === "optimistic"
                          ? "#f0faf0"
                          : "#f9f0ff",
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <MDTypography variant="h5" sx={{ fontSize: 26 }}>
                      {ot === "pessimistic" ? "⚠" : ot === "optimistic" ? "✓" : "~"}
                    </MDTypography>
                    <MDBox>
                      <MDTypography variant="caption" color="text.secondary">
                        Overall Signpost Trend
                      </MDTypography>
                      <MDTypography
                        variant="h6"
                        sx={{
                          color:
                            ot === "pessimistic"
                              ? "#f57c00"
                              : ot === "optimistic"
                              ? "#388e3c"
                              : "#8e24aa",
                        }}
                      >
                        {ot === "pessimistic"
                          ? "Worsening — signposts moving toward worst-case thresholds"
                          : ot === "optimistic"
                          ? "Improving — signposts moving toward best-case thresholds"
                          : "Mixed signals — some signposts worsening, others improving"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                );
              })()}
              <Grid item md={12}>
                <Divider sx={{ my: 2 }} />
                {/* ID198 — the group heading; Suggest Signposts now lives in the quantitative section below. */}
                <MDTypography variant="h5" sx={{ color: "#52009b", fontWeight: 700, pt: 1 }}>
                  Live Monitoring Detail
                </MDTypography>
                {!(RiskDetails.id || RiskDetails._id) && (
                  <MDTypography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                    Save the risk first to add signposts.
                  </MDTypography>
                )}
              </Grid>
              <Grid item md={12}>
                {/* Live monitoring summary with history moved up to below the scenario table (ID214). */}
                {/* Themes for this risk — the default per-risk horizon scan (multi-lens, refreshed
                    daily). Rendered as its own panel, not as a signpost row. */}
                {riskHorizonSp && (
                  <Card sx={{ mb: 2, p: 2, border: "1px solid rgba(82,0,155,0.2)" }}>
                    <MDBox
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      <MDTypography variant="subtitle2" fontWeight="bold" sx={{ color: "#52009b" }}>
                        Signals – qualitative monitoring
                        <MDTypography
                          component="span"
                          variant="caption"
                          sx={{ color: "text.secondary", ml: 1 }}
                        >
                          horizon scan ·{" "}
                          {horizonScanning
                            ? "scanning…"
                            : riskHorizonSp.horizonScannedAt
                            ? new Date(riskHorizonSp.horizonScannedAt).toLocaleDateString()
                            : "not yet run"}
                        </MDTypography>
                      </MDTypography>
                      <MDButton
                        size="small"
                        variant="outlined"
                        onClick={rescanRiskHorizon}
                        disabled={horizonScanning}
                        sx={{ color: "#52009b", borderColor: "#52009b", textTransform: "none" }}
                      >
                        {horizonScanning ? "Scanning…" : "Rescan"}
                      </MDButton>
                    </MDBox>
                    <TextField
                      size="small"
                      placeholder="Add your own focus for this scan (optional) — then Rescan"
                      value={horizonQuery}
                      onChange={(e) => setHorizonQuery(e.target.value)}
                      disabled={horizonScanning}
                      fullWidth
                      sx={{ mb: 1.5, maxWidth: 560 }}
                      helperText="Scans Global, geography, sector & organisation lenses by default. Add a focus (e.g. a supplier, region or event) to weight the scan toward it."
                    />
                    {(riskHorizonSp.horizonThemes || []).length === 0 ? (
                      <MDBox>
                        {horizonScanning ? (
                          // "Generating…" state: blurred skeleton cards behind a centred spinner +
                          // message, so the wait reads as work-in-progress rather than an empty panel.
                          <MDBox sx={{ position: "relative", minHeight: 190 }}>
                            <MDBox
                              sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                                gap: 1.25,
                                filter: "blur(3px)",
                                opacity: 0.55,
                                pointerEvents: "none",
                              }}
                            >
                              {[0, 1, 2, 3].map((k) => (
                                <MDBox
                                  key={k}
                                  sx={{
                                    border: "1px solid #e3e8ec",
                                    borderRadius: "10px",
                                    p: 1.25,
                                    height: 96,
                                  }}
                                >
                                  <MDBox
                                    sx={{
                                      width: 60,
                                      height: 12,
                                      bgcolor: "#e6e0ef",
                                      borderRadius: 1,
                                      mb: 1,
                                    }}
                                  />
                                  <MDBox
                                    sx={{
                                      width: "90%",
                                      height: 12,
                                      bgcolor: "#ece7f3",
                                      borderRadius: 1,
                                      mb: 0.75,
                                    }}
                                  />
                                  <MDBox
                                    sx={{
                                      width: "70%",
                                      height: 12,
                                      bgcolor: "#ece7f3",
                                      borderRadius: 1,
                                    }}
                                  />
                                </MDBox>
                              ))}
                            </MDBox>
                            <MDBox
                              sx={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                gap: 1,
                                bgcolor: "rgba(255,255,255,0.55)",
                                backdropFilter: "blur(1px)",
                                borderRadius: "10px",
                                px: 2,
                              }}
                            >
                              <CircularProgress size={30} sx={{ color: "#52009b" }} />
                              <MDTypography
                                variant="button"
                                fontWeight="bold"
                                sx={{ color: "#52009b" }}
                              >
                                Generating horizon themes for this risk…
                              </MDTypography>
                              <MDTypography
                                variant="caption"
                                color="text.secondary"
                                sx={{ maxWidth: 440 }}
                              >
                                Scanning Global, geography, sector and organisation news (~20s).
                                You&apos;ll be able to review the themes and add or remove any once
                                they appear below.
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        ) : (
                          <MDTypography variant="body2" color="text.secondary">
                            No themes yet — the scan runs on create and refreshes daily. Use Rescan
                            to run it now.
                          </MDTypography>
                        )}
                      </MDBox>
                    ) : (
                      <>
                        <MDBox
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                            gap: 1.25,
                          }}
                        >
                          {(showAllThemes
                            ? riskHorizonSp.horizonThemes || []
                            : (riskHorizonSp.horizonThemes || []).slice(0, 6)
                          ).map((t) => (
                            <MDBox
                              key={t.theme}
                              role="button"
                              tabIndex={0}
                              onClick={() => {
                                setThemeDetail(t);
                                setThemeDetailOpen(true);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  setThemeDetail(t);
                                  setThemeDetailOpen(true);
                                }
                              }}
                              sx={{
                                border: "1px solid #e3e8ec",
                                borderRadius: "10px",
                                p: 1.25,
                                cursor: "pointer",
                                transition: "border-color 120ms, box-shadow 120ms",
                                "&:hover": {
                                  borderColor: "#52009b",
                                  boxShadow: "0 2px 10px rgba(82,0,155,0.12)",
                                },
                              }}
                            >
                              <MDBox
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  justifyContent: "space-between",
                                  gap: 1,
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: 700,
                                    color: "#152230",
                                    fontSize: "0.9rem",
                                    lineHeight: 1.25,
                                  }}
                                >
                                  {t.theme}
                                </div>
                                <MuiTooltip title="Remove this theme (won't come back on a rescan)">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      hideHorizonTheme(t.theme);
                                    }}
                                    sx={{
                                      p: 0.25,
                                      mt: "-2px",
                                      color: "#9e9e9e",
                                      "&:hover": { color: "#c62828" },
                                    }}
                                  >
                                    <Icon sx={{ fontSize: "16px !important" }}>close</Icon>
                                  </IconButton>
                                </MuiTooltip>
                              </MDBox>
                              {t.whyItMatters && (
                                <div
                                  style={{
                                    color: "#5B6B78",
                                    fontSize: "0.78rem",
                                    marginTop: 4,
                                    lineHeight: 1.45,
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  {t.whyItMatters}
                                </div>
                              )}
                              <div
                                style={{
                                  marginTop: 8,
                                  fontSize: "0.7rem",
                                  fontWeight: 700,
                                  color: "#52009b",
                                }}
                              >
                                {(t.evidence || []).length} article
                                {(t.evidence || []).length === 1 ? "" : "s"} · view detail ›
                              </div>
                            </MDBox>
                          ))}
                        </MDBox>
                        {(riskHorizonSp.horizonThemes || []).length > 6 && (
                          <MDButton
                            size="small"
                            variant="text"
                            onClick={() => setShowAllThemes((s) => !s)}
                            sx={{ color: "#52009b", textTransform: "none", mt: 1 }}
                          >
                            {showAllThemes
                              ? "Show top 6"
                              : `Show all ${(riskHorizonSp.horizonThemes || []).length}`}
                          </MDButton>
                        )}
                      </>
                    )}
                  </Card>
                )}
                {signpostsLoading ? (
                  <MDTypography variant="body2" sx={{ p: 2 }}>
                    Loading signposts…
                  </MDTypography>
                ) : (
                  <MDBox>
                    {/* ID198 — Signposts (quantitative monitoring) section; Suggest Signposts lives here. */}
                    <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      flexWrap="wrap"
                      gap={1}
                      mb={1}
                    >
                      <MDTypography variant="subtitle2" fontWeight="bold" sx={{ color: "#52009b" }}>
                        Signposts – quantitative monitoring
                      </MDTypography>
                      <Box display="flex" gap={1} flexWrap="wrap">
                        {/* One merged modal: Library (default) → ✨ Suggest new with AI → 🔍 Web. */}
                        <MDButton
                          variant="outlined"
                          size="small"
                          disabled={!(RiskDetails.id || RiskDetails._id)}
                          onClick={() => setFinderOpen(true)}
                          sx={{
                            color: "#52009b",
                            borderColor: "#52009b",
                            textTransform: "none",
                            "&:hover": { borderColor: "#3a0070" },
                          }}
                        >
                          + Add signposts
                        </MDButton>
                      </Box>
                    </MDBox>
                    {normalSignposts.length > 0 && (
                      <CombinedSignpostChart signposts={normalSignposts} execute={execute} />
                    )}

                    {normalSignposts.length === 0 && (
                      <MDTypography variant="body2" color="text.secondary" sx={{ px: 0, pb: 2 }}>
                        No quantitative signposts yet. Click &quot;+ Add signposts&quot; to pick
                        from the library, have AI suggest new ones, or search the web.
                      </MDTypography>
                    )}

                    {normalSignposts.map((sp) => {
                      const spId = String(sp._id || sp.id);
                      const isEditingSp = editMode; // all signposts editable together in edit mode
                      const spDraft = editingSpDrafts[spId] || { thresholds: [] };
                      return (
                        <Card key={spId} sx={{ mb: 2, p: 2 }}>
                          <MDBox display="flex" alignItems="center" gap={1} mb={1}>
                            {isEditingSp ? (
                              <TextField
                                size="small"
                                fullWidth
                                label="Signpost name"
                                value={spDraft.name !== undefined ? spDraft.name : sp.name || ""}
                                onChange={(e) =>
                                  updateSpDraft(spId, (cur) => ({ ...cur, name: e.target.value }))
                                }
                                sx={{ flex: 1 }}
                              />
                            ) : (
                              <MDTypography variant="h6" sx={{ flex: 1 }}>
                                {sp.name ||
                                  signpostLibraryList.find(
                                    (l) => String(l._id || l.id) === String(sp.signpostLibraryId)
                                  )?.name ||
                                  sp.desc ||
                                  "Signpost"}
                              </MDTypography>
                            )}
                            {!isEditingSp && (
                              <MuiTooltip title="Recompute trend from existing data points">
                                <MDButton
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    color: "#52009b",
                                    borderColor: "#52009b",
                                    textTransform: "none",
                                    fontSize: 11,
                                  }}
                                  onClick={() =>
                                    execute(
                                      "POST",
                                      `${protectedResources.apiTodoList.endpoint}/emergingRisk/signposts/${spId}/reassess`,
                                      {}
                                    ).then((res) => {
                                      if (res?.data) {
                                        setActiveSignposts((prev) =>
                                          prev.map((s) =>
                                            String(s._id || s.id) === spId
                                              ? { ...s, lastAssessment: res.data.lastAssessment }
                                              : s
                                          )
                                        );
                                      }
                                    })
                                  }
                                >
                                  Reassess
                                </MDButton>
                              </MuiTooltip>
                            )}
                            {/* ID164 — edit this signpost: enter edit mode (whole record editable,
                                with the sticky Save/Discard bar) right from the signpost. */}
                            {!isEditingSp && (
                              <MuiTooltip title="Edit this signpost">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    originalSnapshot.current = {
                                      riskDetails: { ...RiskDetails },
                                      scenarios: scenarios.map((s) => ({ ...s })),
                                    };
                                    setEditMode(true);
                                  }}
                                >
                                  <EditIcon fontSize="small" sx={{ color: "#52009b" }} />
                                </IconButton>
                              </MuiTooltip>
                            )}
                            <Chip
                              label={sp.subType || "quantitative"}
                              size="small"
                              color={sp.subType === "qualitative" ? "info" : "default"}
                              variant="outlined"
                            />
                            {sp.alertStatus && sp.alertStatus !== "none" && (
                              <Chip
                                label={sp.alertStatus.toUpperCase()}
                                size="small"
                                color={sp.alertStatus === "red" ? "error" : "warning"}
                              />
                            )}
                            {/* ID164 — signpost requested from an external source, not yet wired up. */}
                            {sp.requestStatus === "pending" && (
                              <MuiTooltip title="This source has been requested and is awaiting set-up by the team.">
                                <Chip
                                  label={`Requested${
                                    sp.requestCaseNumber ? ` · ${sp.requestCaseNumber}` : ""
                                  } — not yet added`}
                                  size="small"
                                  sx={{
                                    bgcolor: "#fff3e0",
                                    color: "#e65100",
                                    border: "1px solid #ffb74d",
                                    fontWeight: 700,
                                  }}
                                />
                              </MuiTooltip>
                            )}
                            {editMode && (
                              <MuiTooltip title="Delete signpost">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleDeleteSignpost(spId)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </MuiTooltip>
                            )}
                          </MDBox>
                          {/* What this signpost is + where the data comes from (item 93) */}
                          {(() => {
                            const lib = signpostLibraryList.find(
                              (l) => String(l._id || l.id) === String(sp.signpostLibraryId)
                            );
                            const desc = sp.desc || lib?.description || "";
                            const srcUrl =
                              lib?.dataSourceConfig?.url ||
                              lib?.dataSourceConfig?.link ||
                              lib?.provider ||
                              "";
                            if (!desc && !srcUrl && !lib?.dataSourceType) return null;
                            return (
                              <MDBox mb={1}>
                                {!isEditingSp && desc && (
                                  <MDTypography variant="body2" color="text.secondary">
                                    {desc}
                                  </MDTypography>
                                )}
                                <MDBox sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 0.25 }}>
                                  {lib?.dataSourceType && (
                                    <Chip
                                      size="small"
                                      variant="outlined"
                                      label={`Source: ${lib.dataSourceType}`}
                                      sx={{ fontSize: 11 }}
                                    />
                                  )}
                                  {srcUrl && (
                                    <Link
                                      href={
                                        /^https?:\/\//.test(srcUrl) ? srcUrl : `https://${srcUrl}`
                                      }
                                      target="_blank"
                                      rel="noopener"
                                      sx={{ fontSize: "0.75rem" }}
                                    >
                                      View data source ↗
                                    </Link>
                                  )}
                                </MDBox>
                              </MDBox>
                            );
                          })()}
                          {isEditingSp ? (
                            <MDBox mb={1} display="flex" flexDirection="column" gap={1.5}>
                              <TextField
                                size="small"
                                fullWidth
                                multiline
                                minRows={2}
                                label="Description"
                                value={spDraft.desc !== undefined ? spDraft.desc : sp.desc || ""}
                                onChange={(e) =>
                                  updateSpDraft(spId, (cur) => ({ ...cur, desc: e.target.value }))
                                }
                              />
                              <MDBox
                                display="flex"
                                alignItems="center"
                                gap={1}
                                flexWrap="wrap"
                                sx={{ mt: 0.5 }}
                              >
                                <MDTypography variant="subtitle2" sx={{ color: "#52009b" }}>
                                  Thresholds
                                </MDTypography>
                                {sp.subType !== "qualitative" && (
                                  <MuiTooltip title="Derive best/worst case from this signpost's history (moving average ± 2σ + seasonality)">
                                    <span>
                                      <MDButton
                                        size="small"
                                        variant="outlined"
                                        disabled={!!spSuggestBusy[spId]}
                                        sx={{
                                          color: "#52009b",
                                          borderColor: "#52009b",
                                          textTransform: "none",
                                          fontSize: 11,
                                          py: 0.25,
                                        }}
                                        onClick={() => suggestThresholdsFor(sp)}
                                      >
                                        {spSuggestBusy[spId]
                                          ? "Suggesting…"
                                          : "✨ Suggest thresholds"}
                                      </MDButton>
                                    </span>
                                  </MuiTooltip>
                                )}
                              </MDBox>
                              {spSuggestNote[spId] && (
                                <MDTypography
                                  variant="caption"
                                  sx={{ color: "text.secondary", display: "block", mb: 0.5 }}
                                >
                                  {spSuggestNote[spId]}
                                </MDTypography>
                              )}
                              {(spDraft.thresholds || []).map((t, ti) => (
                                <MDBox
                                  key={ti}
                                  display="flex"
                                  gap={1}
                                  alignItems="center"
                                  flexWrap="wrap"
                                >
                                  <Autocomplete
                                    size="small"
                                    sx={{ width: 170 }}
                                    value={t.scenarioLabel || ""}
                                    onChange={(_, v) =>
                                      updateSpDraft(spId, (d) => {
                                        const ts = [...d.thresholds];
                                        const sc = findScenarioByLabel(v);
                                        const amt = scenarioAmount(sc);
                                        ts[ti] = {
                                          ...ts[ti],
                                          scenarioLabel: v || "",
                                          scenario: sc
                                            ? scenarioToKey(sc)
                                            : ts[ti].scenario || "base",
                                          value: amt != null ? amt : ts[ti].value,
                                        };
                                        return { ...d, thresholds: ts };
                                      })
                                    }
                                    options={scenarioOptionLabels}
                                    renderInput={(params) => (
                                      <TextField {...params} label="Scenario" />
                                    )}
                                  />
                                  <Autocomplete
                                    size="small"
                                    sx={{ width: 120 }}
                                    value={t.direction || "above"}
                                    onChange={(_, v) =>
                                      updateSpDraft(spId, (d) => {
                                        const ts = [...d.thresholds];
                                        ts[ti] = { ...ts[ti], direction: v || "above" };
                                        return { ...d, thresholds: ts };
                                      })
                                    }
                                    options={["above", "below"]}
                                    renderInput={(params) => (
                                      <TextField {...params} label="Direction" />
                                    )}
                                  />
                                  <TextField
                                    size="small"
                                    label="Value"
                                    type="number"
                                    sx={{ width: 100 }}
                                    value={t.value ?? ""}
                                    onChange={(e) =>
                                      updateSpDraft(spId, (d) => {
                                        const ts = [...d.thresholds];
                                        ts[ti] = { ...ts[ti], value: parseFloat(e.target.value) };
                                        return { ...d, thresholds: ts };
                                      })
                                    }
                                  />
                                  <TextField
                                    size="small"
                                    label="What it represents (%, USD, rating…)"
                                    sx={{ width: 220 }}
                                    value={t.description || ""}
                                    onChange={(e) =>
                                      updateSpDraft(spId, (d) => {
                                        const ts = [...d.thresholds];
                                        ts[ti] = { ...ts[ti], description: e.target.value };
                                        return { ...d, thresholds: ts };
                                      })
                                    }
                                  />
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      updateSpDraft(spId, (d) => ({
                                        ...d,
                                        thresholds: d.thresholds.filter((_, i) => i !== ti),
                                      }))
                                    }
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </MDBox>
                              ))}
                              <MDButton
                                size="small"
                                variant="outlined"
                                sx={{
                                  color: "#52009b",
                                  borderColor: "#52009b",
                                  textTransform: "none",
                                  alignSelf: "flex-start",
                                }}
                                onClick={() =>
                                  updateSpDraft(spId, (d) => ({
                                    ...d,
                                    thresholds: [
                                      ...(d.thresholds || []),
                                      {
                                        scenario: "base",
                                        scenarioLabel: "",
                                        direction: "above",
                                        value: 0,
                                        description: "",
                                      },
                                    ],
                                  }))
                                }
                              >
                                + Add Threshold
                              </MDButton>
                            </MDBox>
                          ) : null}
                          {sp.subType === "quantitative" ? (
                            <SignpostChart
                              signpostId={sp._id || sp.id}
                              thresholds={sp.thresholds || []}
                              unit={sp.unit || ""}
                              execute={execute}
                              lastAssessment={sp.lastAssessment || null}
                            />
                          ) : (
                            <QualitativeSignpostCard signpost={sp} />
                          )}
                          {(sp.thresholds?.length > 0 || sp.triggers?.length > 0) && (
                            <MDBox mt={1}>
                              {sp.thresholds?.map((t, i) => (
                                <Chip
                                  key={i}
                                  size="small"
                                  variant="outlined"
                                  sx={{ mr: 0.5, mb: 0.5, fontSize: "11px" }}
                                  label={`${t.scenario}: ${t.direction} ${t.value}${
                                    t.scenarioLabel ? ` (${t.scenarioLabel})` : ""
                                  }`}
                                />
                              ))}
                              {sp.triggers?.map((t, i) => (
                                <Chip
                                  key={i}
                                  size="small"
                                  variant="outlined"
                                  color="info"
                                  sx={{ mr: 0.5, mb: 0.5, fontSize: "11px" }}
                                  label={`${t.scenario}: ${t.description?.slice(0, 40)}${
                                    t.description?.length > 40 ? "…" : ""
                                  }`}
                                />
                              ))}
                            </MDBox>
                          )}
                        </Card>
                      );
                    })}
                  </MDBox>
                )}
              </Grid>
              <Grid item md={12}>
                <Scenario RiskDetails={RiskDetails} />
              </Grid>
            </MDBox>
          </MDBox>
        </Grid>
      ) : (
        ""
      )}
      <SignpostFinderDialog
        open={finderOpen}
        onClose={() => setFinderOpen(false)}
        riskId={RiskDetails.id || (RiskDetails._id && String(RiskDetails._id))}
        execute={execute}
        onAttached={() => {
          // Leave the create stepper and show the risk's signpost list so the newly
          // attached signpost(s) are visible (set thresholds, reassess, activate from there).
          setCreateRisk(false);
          setShowSignPost(true);
          setFromAddSignpost(false);
          setSignpostDialogOpen(false); // ID89 — close the add-signpost pop-up too
          setReload((r) => !r);
        }}
        onCreated={(list) => {
          // AI "Suggest new with AI" created signposts from inside the merged modal — show the same
          // post-create confirmation (created signposts + suggested thresholds) as the old flow.
          setConfirmSpList(list);
          setConfirmSpOpen(true);
          setCreateRisk(false);
          setShowSignPost(true);
          setFromAddSignpost(false);
          setSignpostDialogOpen(false);
          setReload((r) => !r);
        }}
      />

      {/* ID199 — qualitative theme detail pop-up: what's happening / why it matters + articles */}
      <Dialog
        open={themeDetailOpen}
        onClose={() => setThemeDetailOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: "#52009b", fontWeight: 700 }}>
          {themeDetail?.theme || "Theme"}
        </DialogTitle>
        <DialogContent dividers>
          {themeDetail?.summary && (
            <>
              <MDTypography
                variant="subtitle2"
                fontWeight="bold"
                sx={{ color: "#52009b", mb: 0.5 }}
              >
                What is happening
              </MDTypography>
              <MDTypography variant="body2" sx={{ mb: 2, lineHeight: 1.6 }}>
                {themeDetail.summary}
              </MDTypography>
            </>
          )}
          {themeDetail?.whyItMatters && (
            <>
              <MDTypography
                variant="subtitle2"
                fontWeight="bold"
                sx={{ color: "#52009b", mb: 0.5 }}
              >
                Why it matters
              </MDTypography>
              <MDTypography variant="body2" sx={{ mb: 2, lineHeight: 1.6 }}>
                {themeDetail.whyItMatters}
              </MDTypography>
            </>
          )}
          <MDTypography variant="subtitle2" fontWeight="bold" sx={{ color: "#52009b", mb: 0.5 }}>
            News stream ({(themeDetail?.evidence || []).length})
          </MDTypography>
          {(themeDetail?.evidence || []).length === 0 ? (
            <MDTypography variant="caption" color="text.secondary">
              No news sources found for this theme yet — click Rescan to fetch them.
            </MDTypography>
          ) : (
            <MDBox sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
              {(themeDetail?.evidence || []).map((e, ei) => (
                <a
                  key={e.url || e.title || ei}
                  href={e.url || "#"}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "flex",
                    gap: 6,
                    alignItems: "baseline",
                    fontSize: "0.8rem",
                    lineHeight: 1.4,
                    color: "#152230",
                    textDecoration: "none",
                  }}
                >
                  <span style={{ color: "#52009b", flex: "none" }}>▸</span>
                  <span style={{ flex: 1 }}>
                    {e.title || e.url}
                    {e.source && <span style={{ color: "#5B6B78" }}> — {e.source}</span>}
                  </span>
                </a>
              ))}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="text"
            onClick={() => setThemeDetailOpen(false)}
            sx={{ textTransform: "none" }}
          >
            Close
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Post-create confirmation: what was created + suggested thresholds + responsibility notice */}
      <Dialog open={confirmSpOpen} onClose={() => setConfirmSpOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: "#52009b", fontWeight: 700 }}>Signposts created</DialogTitle>
        <DialogContent dividers>
          <MDTypography variant="body2" sx={{ mb: 1.5 }}>
            {confirmSpList.length} signpost{confirmSpList.length === 1 ? " was" : "s were"} created
            with the AI-suggested thresholds below, and added to the Signposts list. Review them —
            you can adjust any threshold there. By setting these up you accept responsibility for
            monitoring them.
          </MDTypography>
          {confirmSpList.map((q, qi) => (
            <MDBox
              key={q.name || qi}
              sx={{ border: "1px solid #e7e2ee", borderRadius: 1, p: 1.25, mb: 1 }}
            >
              <MDTypography variant="button" fontWeight="bold" sx={{ display: "block" }}>
                {q.name || "Signpost"}
                {q.unit ? (
                  <MDTypography component="span" variant="caption" sx={{ color: "text.secondary" }}>
                    {" "}
                    ({q.unit})
                  </MDTypography>
                ) : null}
              </MDTypography>
              {(q.thresholds || []).length === 0 ? (
                <MDTypography variant="caption" color="text.secondary">
                  No thresholds suggested.
                </MDTypography>
              ) : (
                (q.thresholds || []).map((t, ti) => (
                  <MDTypography
                    key={ti}
                    variant="caption"
                    sx={{ display: "block", color: "#374151" }}
                  >
                    • {t.label ? `${t.label}: ` : ""}
                    {t.value}
                    {t.scenario ? ` (${t.scenario})` : ""}
                  </MDTypography>
                ))
              )}
            </MDBox>
          ))}
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="contained"
            onClick={() => setConfirmSpOpen(false)}
            sx={{ bgcolor: "#52009b", color: "#fff", "&:hover": { bgcolor: "#3a0070" } }}
          >
            Done
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Phase 3 — AI "Suggest signposts" proposal review (design agent) */}
      <Dialog open={suggestOpen} onClose={() => setSuggestOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ color: "#52009b", fontWeight: 700 }}>
          ✨ Suggested signposts — {RiskDetails.Title || "risk"}
        </DialogTitle>
        <DialogContent dividers>
          {suggestLoading && (
            <MDTypography variant="body2" color="text.secondary">
              Researching real proxies and validating live data feeds… (~15–25s)
            </MDTypography>
          )}
          {!suggestLoading && suggestions?.error && (
            <MDTypography variant="body2" color="error">
              Couldn&apos;t generate suggestions. Check the design agent is configured
              (INGEST_FUNCTION_URL) and try again.
            </MDTypography>
          )}
          {!suggestLoading && suggestions && !suggestions.error && (
            <Box>
              {suggestions.summary && (
                <MDTypography variant="body2" sx={{ mb: 2, fontStyle: "italic", color: "#555" }}>
                  {suggestions.summary}
                </MDTypography>
              )}

              <MDTypography variant="h6" sx={{ color: "#52009b", mb: 1 }}>
                Quantitative signposts ({(suggestions.quantitative || []).length})
              </MDTypography>
              {(suggestions.quantitative || []).map((q, i) => (
                <Box key={`q${i}`} display="flex" alignItems="flex-start" gap={1} sx={{ mb: 1.5 }}>
                  <Checkbox
                    checked={!!pickQuant[i]}
                    onChange={(e) => setPickQuant((p) => ({ ...p, [i]: e.target.checked }))}
                    sx={{ p: 0, mt: 0.3 }}
                  />
                  <Box>
                    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                      <MDTypography variant="button" fontWeight="bold">
                        {q.name}
                      </MDTypography>
                      <Chip
                        size="small"
                        label={q.feed_validated ? "✓ live feed" : "unvalidated"}
                        sx={{
                          bgcolor: q.feed_validated ? "#e8f5e9" : "#eeeeee",
                          color: q.feed_validated ? "#2e7d32" : "#777",
                          fontSize: 11,
                        }}
                      />
                      <Chip
                        size="small"
                        variant="outlined"
                        label={`${q.dataSourceType} · ${
                          q.direction === "lower_is_worse" ? "lower=worse" : "higher=worse"
                        }`}
                        sx={{ fontSize: 11 }}
                      />
                    </Box>
                    <MDTypography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block" }}
                    >
                      {JSON.stringify(q.config)} {q.unit ? `· ${q.unit}` : ""}
                    </MDTypography>
                    <MDTypography variant="caption" sx={{ display: "block", color: "#555" }}>
                      {q.rationale}
                    </MDTypography>
                  </Box>
                </Box>
              ))}

              {/* Qualitative trigger-events are no longer suggested here — qualitative signals are
                  covered by the risk's linked Horizon Scan theme. Quantitative signposts only.
              <Divider sx={{ my: 2 }} />

              <MDTypography variant="h6" sx={{ color: "#52009b", mb: 1 }}>
                Qualitative trigger-events ({(suggestions.qualitativeTriggers || []).length})
              </MDTypography>
              {(suggestions.qualitativeTriggers || []).map((t, i) => (
                <Box key={`t${i}`} display="flex" alignItems="flex-start" gap={1} sx={{ mb: 1.5 }}>
                  <Checkbox
                    checked={!!pickTrig[i]}
                    onChange={(e) => setPickTrig((p) => ({ ...p, [i]: e.target.checked }))}
                    sx={{ p: 0, mt: 0.3 }}
                  />
                  <Box>
                    <MDTypography variant="button" fontWeight="medium" sx={{ display: "block" }}>
                      {t.description}
                    </MDTypography>
                    <MDTypography variant="caption" sx={{ color: "#555" }}>
                      {t.rationale}
                    </MDTypography>
                  </Box>
                </Box>
              ))}
              */}

              {suggestions.stats && (
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mt: 2 }}
                >
                  {suggestions.stats.searches} searches · {suggestions.stats.tickerTests} feeds
                  tested · ~${Number(suggestions.stats.costUsd || 0).toFixed(3)}
                </MDTypography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton variant="text" onClick={() => setSuggestOpen(false)} disabled={creatingSp}>
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            sx={{ bgcolor: "#52009b", color: "#fff", "&:hover": { bgcolor: "#3a0070" } }}
            disabled={suggestLoading || creatingSp || !suggestions || suggestions.error}
            onClick={createSelectedSignposts}
          >
            {creatingSp ? "Creating…" : "Create selected"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* ID89 — "+ Add Signpost" pop-up (merged watchlist risk details) */}
      <Dialog
        open={signpostDialogOpen}
        onClose={() => setSignpostDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ color: "#52009b", fontWeight: 700 }}>Add Signpost</DialogTitle>
        <DialogContent dividers>
          <AddSignpostForm
            spName={spName}
            setSpName={setSpName}
            spDesc={spDesc}
            setSpDesc={setSpDesc}
            signpostSubType={signpostSubType}
            setSignpostSubType={setSignpostSubType}
            signpostLibraryList={signpostLibraryList}
            selectedLibraryEntry={selectedLibraryEntry}
            setSelectedLibraryEntry={setSelectedLibraryEntry}
            handleSelectSignPost={handleSelectSignPost}
            spThresholds={spThresholds}
            setSpThresholds={setSpThresholds}
            spTriggers={spTriggers}
            setSpTriggers={setSpTriggers}
            scenarioOptionLabels={scenarioOptionLabels}
            findScenarioByLabel={findScenarioByLabel}
            scenarioAmount={scenarioAmount}
            scenarioToKey={scenarioToKey}
            riskId={RiskDetails.id || RiskDetails._id}
            onOpenFinder={() => setFinderOpen(true)}
            prioritisationMatrix={evalCriteria.prioritisationMatrix}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton onClick={() => setSignpostDialogOpen(false)} sx={{ color: "#52009b" }}>
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            sx={{ bgcolor: "#52009b", color: "#fff" }}
            onClick={saveSignPost}
          >
            Save Signpost
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Publish disclaimer — tick-to-confirm gate before a draft goes live (PO 2026-09-09). */}
      <Dialog
        open={publishConfirmOpen}
        onClose={() => setPublishConfirmOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: "#52009b", fontWeight: 700 }}>Publish this risk</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.7, mb: 1.5 }}>
            I confirm this risk assessment reflects my organisation&apos;s own judgement. It is for
            internal risk-management purposes only and does not constitute financial, legal, or
            investment advice. AI-generated content has been reviewed for accuracy.
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={publishAck}
                onChange={(e) => setPublishAck(e.target.checked)}
                sx={{ color: "#52009b", "&.Mui-checked": { color: "#52009b" } }}
              />
            }
            label="I understand and confirm the above."
          />
        </DialogContent>
        <DialogActions>
          <MDButton
            size="small"
            variant="outlined"
            color="dark"
            onClick={() => setPublishConfirmOpen(false)}
          >
            Cancel
          </MDButton>
          <MDButton
            size="small"
            variant="contained"
            disabled={!publishAck}
            onClick={confirmPublish}
            sx={{ bgcolor: "#52009b" }}
          >
            Publish
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Searchable pop-up to link a Horizon Scan theme — no longer surfaced in the form; kept
          dormant so any deep-link/legacy path still resolves. */}
      <Dialog
        open={themePickerOpen}
        onClose={() => setThemePickerOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: "#52009b", fontWeight: 700 }}>
          Link a Horizon Scan Theme
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            fullWidth
            size="small"
            placeholder="Search themes…"
            value={themeSearch}
            onChange={(e) => setThemeSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#52009b" }} />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 1.5 }}
          />
          <MDBox sx={{ maxHeight: 340, overflowY: "auto" }}>
            {(() => {
              const q = themeSearch.trim().toLowerCase();
              const list = (horizonThemes || []).filter(
                (t) => !q || String(t).toLowerCase().includes(q)
              );
              if (list.length === 0) {
                return (
                  <MDTypography variant="body2" color="text" sx={{ p: 1.5 }}>
                    {horizonThemes.length === 0
                      ? "No Horizon Scan themes available yet."
                      : "No themes match your search."}
                  </MDTypography>
                );
              }
              return list.map((t) => {
                const selected = t === linkedHorizonTheme;
                return (
                  <MDBox
                    key={t}
                    onClick={() => {
                      setLinkedHorizonTheme(t);
                      setFormErrors((prev) => ({ ...prev, linkedHorizonTheme: "" }));
                      setThemePickerOpen(false);
                    }}
                    sx={{
                      px: 1.5,
                      py: 1,
                      cursor: "pointer",
                      borderRadius: 1,
                      borderBottom: "1px solid rgba(0,0,0,0.06)",
                      bgcolor: selected ? "rgba(82,0,155,0.10)" : "transparent",
                      "&:hover": { bgcolor: "rgba(82,0,155,0.06)" },
                    }}
                  >
                    <MDTypography
                      variant="body2"
                      sx={{ fontWeight: selected ? 700 : 500, color: "#1a1a1a" }}
                    >
                      {t}
                      {selected ? " ✓" : ""}
                    </MDTypography>
                  </MDBox>
                );
              });
            })()}
          </MDBox>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton onClick={() => setThemePickerOpen(false)} sx={{ color: "#52009b" }}>
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* ID79/ID172 — Plausibility picker. In timeframe_velocity mode a row sets both the velocity
          (rating) and the time horizon; in likelihood mode it sets the likelihood band. */}
      <PlausibilityPickerDialog
        open={plausPickerOpen}
        onClose={() => setPlausPickerOpen(false)}
        rows={isLikelihoodMode ? evalCriteria.likelihoodRows : evalCriteria.plausibilityRows}
        mode={evalCriteria.plausibilityMode}
        value={isLikelihoodMode ? likelihood : overallVelocity}
        onSelect={(row) => {
          if (isLikelihoodMode) {
            setLikelihood(row.rating || "");
          } else {
            setOverallVelocity(row.rating || "");
            // Prefer the split Timeframe column; fall back to parsing the rating text for legacy
            // configs that only had the combined "A: Near Term and Fast" rating.
            const l = String(row.timeframe || row.rating || "").toLowerCase();
            setTimeFrame(
              l.includes("near") ? "near-term" : l.includes("long") ? "long-term" : "medium-term"
            );
          }
        }}
      />

      {/* ID80 — Consequence type & level picker (Consequence table) */}
      <ConsequencePickerDialog
        open={consPicker.open}
        onClose={() => setConsPicker({ open: false, scIdx: null })}
        levels={evalCriteria.consequenceLevels}
        rows={evalCriteria.consequenceRows}
        typeValue={consPicker.scIdx != null ? scenarios[consPicker.scIdx]?.consequenceType : ""}
        levelValue={consPicker.scIdx != null ? scenarios[consPicker.scIdx]?.qualitative : ""}
        onSelect={(type, level) => {
          if (consPicker.scIdx == null) return;
          // ID70 — append to the scenario's consequence list (mirrors the first to the legacy fields).
          addConsequence(consPicker.scIdx, type, level);
        }}
      />

      {/* ID195 — restore confirmation: restored risks come back in Draft and must be re-published */}
      <Dialog
        open={restoreDialogOpen}
        onClose={() => setRestoreDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: "#2c7a50", fontWeight: 700 }}>Restore this risk?</DialogTitle>
        <DialogContent>
          <MDTypography variant="body2">
            {restoreTarget?.Title ? <b>{restoreTarget.Title}</b> : "This risk"} will be restored to{" "}
            <b>Draft</b> stage. It will <b>not</b> go back on the radar automatically — you&apos;ll
            need to verify its details and <b>publish</b> it again. We&apos;ll open the full record
            now so you can do that.
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="text"
            onClick={() => setRestoreDialogOpen(false)}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            onClick={handleRestoreRisk}
            sx={{
              bgcolor: "#2c7a50",
              color: "#fff",
              textTransform: "none",
              "&:hover": { bgcolor: "#215c3c" },
            }}
          >
            OK, restore to draft
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default AnticipateEmergingRisk;
